window.dn = window.dn || {};

(function (compose, $, undefined)
{
    /** Prefix id used for adding bounties. */
    compose.AddBountyId = "dn-add-bounty";

    /** Store the most recent drag event when a thumbnail is dragged (rich text editor only) */
    compose.DragEvent = null;

    /** Storing all references to our HTML editors. Depending on dn.constants.UseRichTextEditor these will either be rich text editor objects or text input fields. */
    compose.Editors = {};

    /** The fields used in our form for error checking. This gets filled in anew for each final save of a message. */
    compose.FieldsForErrors = [];

    /** Uploaded file keys will be stored here. */
    compose.FileKeys = {};

    /** Uploaded file types will be stored here. */
    compose.FileTypes = {};

    /** The file picker options */
    compose.FileUploaderOptions = 
    {
        maxFiles: 50,
        globalDropZone: true,
        maxSize: dn.constants.FileMaxBytes,
        videoResolution: '1280x720', // for video record live via webcam
        accept: dn.constants.AllowedFileUploads,
        fromSources: ["local_file_system"],
        storeTo: 
        {
            location: 's3',
            path: 'raw/',
        },
        uploadConfig: 
        {
            intelligent: true
        }
    };

    /** 
     * This is where we'll store whether or not a form has been filled in or not. If we find
     * the current messageKey in this hash, it means we've already filled the form and shouldn't
     * do it again. (Methods that sometimes call compose.FillForm() are called in places that 
     * are done when the form is first setup, but ALSO when the type is being changed, thus the
     * need to keep track of whether we've already done the initial fill-in.)
     */
    compose.FilledForms = {};

    /** 
     * Reference to the latest editor element that had the user's focus. Used in scenarios where
     * the user is doing something external (like clicking the "Embed File" link or inserting text),
     * and we need to know which editor they were last in. By default we will set this to the latest
     * visible compose Body, or if it's a multipart body, it'll be set to the first box. 
     */
    compose.LastEditor = null;

    /** Messages that are currently being edited, used to detect dirty edit forms. */
    compose.MessageEditsInProgress = [];

    /** 
     * This is where we'll store the latest version of any messages being edited.
     * The key for this object will be the Message.MessageKey property.
     */
    compose.Messages = {}

    /** Storing all references to our selectize input fields. */
    compose.Selectize = {};

    /** Prefix id used for setting initial status. */
    compose.SetStatusId = "dn-set-status";

    /** 
     * Our normal topic/selectize option groups. Sometimes we'll change these on the fly,
     * e.g. when someone's composing a message on type that limits the groups that can appear.
     */
    compose.TopicOptionGroups = 
    [
        {value: 0, label: 'Discussion Topics', $order: 1},
        {value: 1, label: 'Open User Groups', $order: 2},
        {value: 2, label: 'Closed User Groups', $order: 3},
        {value: 4, label: 'Private User Groups', $order: 4},
    ];

    // /** 
    //  * Type option groups. 
    //  * 
    //  * TODO: Figure out a way to break these out for groups that are in-play, e.g. 
    //  * if they're posting to the ACME XYZ user group, then maybe the ACME Tip message
    //  * type is the most popular and should be highlighted as well?
    //  */
    // compose.TypeOptionGroups = 
    // [
    //     {value: true, label: 'Most Popular', $order: 1},
    //     {value: false, label: '', $order: 2},
    // ];

    /**
     * Internal function to start the AddBounty dialog, initiated either by clicking 
     * on an existing bounty on the message, or by choosing the "Bounty" type.
     */
    function addBounty($form) 
    {
        var id = $form.attr('id');
        var parentKey = $form.data("parentkey");
        var messageKey = $form.data("messagekey");

        var existingBounty = 0;

        if ($form.data("bounty"))
        {
            if ($form.data("bounty").AwardedMessageKey)
            {
                return;
            }

            if ($form.data("bounty").Amount > 0) 
            {
                existingBounty = $form.data("bounty").Amount;
            }
        }

        compose.AddBounty(existingBounty, $form.data("bounty").IsOpen, function (numTokens) 
        {
            // They've now set a bounty, and we're going to hit our API to record this. 
            // For UX sake, we're going to show the bounty as in effect immediately here.
            // After the API call, if it failed, we'll remove the bounty box.

            var amountPromo = 0.0;

            // save a copy in case we need to revert after a failure
            var oldBountyInfo = JSON.parse(JSON.stringify(($form.data("bounty") || {})));
            var oldTypeId = parseInt($form.data("type-id"));

            if (!existingBounty)
            {
                if (dn.constants.BountyPromotionMaxDouble >= numTokens)
                {
                    amountPromo = numTokens;
                }
                else 
                {
                    amountPromo = dn.constants.BountyPromotionMaxDouble;
                }
            }

            $form.data("bounty").Amount = numTokens + amountPromo;
            $form.data("bounty").IsOpen = true;
            $form.data("type-id", dn.constants.BountyTypeId);

            compose.Selectize[id + '-Type'].clearCache(dn.constants.BountyTypeId); // clear the render cache for this item

            if (!compose.Selectize[id + '-Type'].getValue()) 
            {
                // If for some reason the Bounty Type box is not present, put it in place.
                compose.Selectize[id + '-Type'].addItem(dn.constants.BountyTypeId);
            }

            // now force it to re-render
            compose.Selectize[id + '-Type'].updateOption(dn.constants.BountyTypeId, compose.Selectize[id + '-Type'].options[dn.constants.BountyTypeId]);
            compose.ShowTypeInfo($form, parentKey, dn.constants.BountyTypeId);

            // update the bounty on the message
            $.postJSON('/api/v1/message/' + messageKey + '/bounty/' + numTokens)
            .done(function () 
            {
                // Add onClick handler for the bounty type box, to let them increase the bounty.
                $form.find('.dn-type-bounties').off("click").click
                (
                    function(e) 
                    { 
                        addBounty($form); 
                    }
                );
            })
            .fail(function (xhr, textStatus, errorThrown) 
            {
                // Turns out the bounty save failed for some reason, so reset the type 
                // box and clear bounty info we had initially set.
                $form.data("bounty", oldBountyInfo);
                $form.data("type-id", oldTypeId);

                compose.Selectize[id + '-Type'].clearCache(dn.constants.BountyTypeId); // clear the render cache for this item

                if (oldBountyInfo && oldBountyInfo.Amount > 0)
                {
                    // They did have a bounty prior to this failure, so put it back
                    compose.Selectize[id + '-Type'].updateOption(dn.constants.BountyTypeId, compose.Selectize[id + '-Type'].options[dn.constants.BountyTypeId]);
                }
                else
                {
                    compose.Selectize[id + '-Type'].clear(true); // using `clear` instead of `removeItem` prevents compose.Save() from being called here, which is good
                }

                // Add onClick handler for the bounty type box, to let them increase the bounty.
                $form.find('.dn-type-bounties').off("click").click
                (
                    function(e) 
                    { 
                        addBounty($form); 
                    }
                );

                if (!dn.IsErrorHandledAutomatically(null, xhr, null, errorThrown)) 
                {
                    // The initial request for the message details failed, tell the user
                    var body = dn.FormatApiError(xhr.responseJSON);
                    dn.ShowModal({ title: "Unexpected Error", body: body });
                }
            });
        }, 
        function () 
        {
            // "Add Bounty" modal closed, see if we need to remove Bounty type,
            // for example, if they did not actually attach a bounty...
            if (!$form.data("bounty").Amount) 
            {
                compose.Selectize[id + '-Type'].removeItem(dn.constants.BountyTypeId);
            }
        });
    }

    /** Whether or not the file uploader has been initialized. Prevents dupe script loading. */
    var fileUploaderInitialized = false;

    /**
     * Add a reply to the display of the current discussion. (This function just adds 
     * the reply in the UI, it has nothing to do with posting the reply to the API.)
     */
    function insertReply(parentKey, message)
    {
        console.debug("insertReply", parentKey, message);

        var awardedBounty = dn.message.Current.BountyAwards[message.MessageKey];
        var canEditReply = (dn.user.UserKey === message.Author.UserKey || dn.user.IsAdministrator);
        var voteText = (message.Votes > 0 ? "+" : "") + message.Votes;

        var files = '';

        if (message.FileKeys.length > 0)
        {
            files = '<div class="reply-attachments col-12 pl-0 ml-0 mb-0 mt-2 form-row dn-attachments has-attachments" id="dn-attachments' + message.DiscussionKey + '">';

                for (var i = 0; i < message.FileKeys.length; i++)
                {
                    var fileKey = message.FileKeys[i];
                    var fileType = message.FileTypes[i];

                    if ((message.FileTypes[i] & dn.constants.FileTypes.Image) != 0) // image
                    {
                        // we use "display-" prefix in the `id` here so that we don't collide with thumbnails being shown in compose/reply/draft windows.
                        files += '<div id="display-' + fileKey + '" data-fancybox-trigger="gallery-' + message.MessageKey + '" data-src="/file/' + fileKey + '/lg" data-filetype="' + fileType + '" class="dn-file-wrapper mr-1 mb-1 float-left"><img src="/file/' + fileKey + '/sm" class="img-fluid mh-100 rounded" /></div>';
                    }
                    else // something other than image (use /embed)
                    {
                        // we use "display-" prefix in the `id` here so that we don't collide with thumbnails being shown in compose/reply/draft windows.
                        files += '<div id="display-' + fileKey + '" data-fancybox-trigger="gallery-' + message.MessageKey + '" data-type="iframe" data-src="/file/' + fileKey + '/embed" data-filetype="' + fileType + '" class="dn-file-wrapper mr-1 mb-1 float-left ' + (message.FileTypes[i] == dn.constants.FileTypes.Video ? "video-thumbnail-overlay" : "") + '"><img src="/file/' + fileKey + '/sm" class="img-fluid mh-100 rounded" /></div>';
                    }                                      
                }

            files += '</div>';
        }

        var tags = '';

        message.Tags.forEach(function(tag, index) 
        {
            // Show tags if ANY of the following is true:
            // 
            //  - The tag was used by 2+ taggers, or
            //  - The tag is an official community tag (UserId=0), or
            //  - The viewer is the tagger

            if (tag.NumUses > 1)
            {
                tags += '<div class="dn-tag ml-0" title="' + tag.Name + ' (' + tag.NumUses + ')">' + tag.Name + '</div>';
            }
            else if (dn.constants.TagsOfficial[tag.TagId] === true || message.UserTags.some(function(t) { return t.TagId === tag.TagId }))
            {
                tags += '<div class="dn-tag ml-0" title="' + tag.Name + '">' + tag.Name + '</div>';
            }
        });

        var messageStatus = dn.message.StatusReverse[message.Status] || 'Default';
        var messageStatusNoun = dn.message.StatusNouns[message.Status] || '';
        var escapedName = dn.text.QuoteAttribute(message.Author.FirstName + ' ' + message.Author.LastName);

        // Insert the reply after the parent message it is replying to.
        var $newReply = $('<div data-messagekey="' + message.MessageKey + '" data-userkey="' + message.Author.UserKey + '" data-usertags-count="' + message.UserTags.length + '" data-authorname="' + escapedName + '" class="media dn-reply dn-message dn-message-status-' + messageStatus + ' dn-depth-' + (message.Depth - 1) + ' ' + (awardedBounty ? "dn-bounty-awarded" : "") + '" data-selected="True" data-updated="' + (new Date(message.DateUpdated)).valueOf() + '">\
            <div class="dn-replytop-spacer"></div>\
            <a href="' + message.Author.Link + '" class="avatar avatar-sm avatar-square mr-2">\
                <img alt="" id="dn-profile-photo-' + message.MessageKey + '" src="' + message.Author.UrlProfilePhoto + '" class="avatar avatar-sm avatar-square" />\
            </a>\
            <div class="media-body dn-author-box-reply">\
                <div class="reply-author-timestamp">\
                    <div class="text-muted float-right reply-timestamp">\
                        <a class="text-muted d-inline-block ml-1" href="' + message.Link + '">' +

                            (message.DateLastEdited
                                ? '<span class="datetime-utc" data-locale="en-short" data-title-prefix="Edited: " data-timestamp="' + ((new Date(message.DateLastEdited)).getTime() / 1000) + '">&nbsp;</span> <i class="fas fa-sm fa-pen mr-1"></i>'
                                : ''
                            ) +

                            '<span class="dn-muted-icon" title="Muted Reply" data-toggle="tooltip"><i class="fas fa-comment-alt-slash fa-sm"></i></span>' + 

                            '<span class="datetime-utc dn-datecompleted" data-locale="en-short" data-title-prefix="Posted: " data-timestamp="' + ((new Date(message.DateCompleted)).getTime() / 1000) + '">&nbsp;</span>\
                        </a>\
                    </div>\
                    <button id="mute-' + message.MessageKey + '" class="btn dn-mute-message float-right"\
                                    title="Mute replies to this message"\
                                    data-messagekey="' + message.MessageKey  + '" data-muted="false" >' + 
                    '</button>\
                    <div class="reply-author text-truncate">' + escapedName + ' <span class="ml-1 text-small text-muted dn-author-position">' + dn.text.QuoteAttribute(message.Author.Position || '') + '</span></div>\
                </div>\
                <div class="reply-position mb-2">\
                    <span class="text-muted text-small float-left">' + (message.Author.BusinessName ? '<i>' + dn.text.QuoteAttribute(message.Author.BusinessName) + '</i> in ' : '') + '<span class="d-none d-sm-inline">' + dn.text.QuoteAttribute(message.Author.BusinessCity) + ', </span>' + dn.text.QuoteAttribute(message.Author.BusinessLocation) + '</span>\
                </div>\
            </div>\
            <div class="dn-reply-content">\
                <div class="collapsed-reply-author">' + escapedName + ' <span class="dn-status-area"><span class="badge badge-pill dn-message-status dn-message-status-' + messageStatus + '">' + messageStatusNoun + '</span></span></div>\
                <div class="collapsed-reply-timestamp">\
                    <span class="float-right">' + 

                        (message.DateLastEdited
                            ? '<span class="datetime-utc" data-locale="en-short" data-title-prefix="Edited: " data-timestamp="' + ((new Date(message.DateLastEdited)).getTime() / 1000) + '">&nbsp;</span> <i class="fas fa-sm fa-pen mr-1"></i>'
                            : ''
                        ) +

                        '<span class="dn-muted-icon" title="Muted Reply" data-toggle="tooltip"><i class="fas fa-comment-alt-slash fa-sm"></i></span>' + 

                        '<span class="datetime-utc" data-locale="en-short" data-title-prefix="Posted: " data-timestamp="' + ((new Date(message.DateCompleted)).getTime() / 1000) + '">&nbsp;</span>\
                    </span>\
                </div>\
                <div class="dn-message-body reply-body">' +

                    (message.Author.IsBot ? dn.constants.BotWarningHtml : '') + 
                    // TODO: We need to also render Metadata here as well!
                    message.BodyWithEmbeds +

                '</div>' +

                files +

                '<div class="message-actions d-flex justify-content-between flex-wrap">\
                    <div class="mt-2 p-0 w-auto d-flex">\
                        <div class="btn-group">\
                            <button class="btn btn-sm dn-button dn-compose-button" data-dn-append-to="#reply-to-' + message.MessageKey + '" data-dn-button-label-closed="Reply" data-dn-button-label-open="Save" data-dn-parentkey="' + message.MessageKey + '" data-type-id="' + message.TypeId + '" type="button" aria-expanded="false" aria-controls="reply-to-' + message.MessageKey + '"><i class="fas fa-reply"></i> <span>Reply</span></button>\
                            <button type="button" class="btn dn-button dropdown-toggle dropdown-toggle-split dn-no-outline" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">\
                                <span class="sr-only"></span>\
                            </button>\
                            <div class="dropdown-menu dropdown-menu-sm dn-dropdown-left">\
                                <a class="dropdown-item dn-share" href="#" data-messagekey="' + message.MessageKey + '">\
                                    <i class="fas fa-share"></i><span class="ml-1">Share</span>\
                                </a>\
                            </div>\
                        </div>' +

                        (canEditReply
                            ? '<button class="btn btn-sm dn-button dn-compose-button dn-edit-button ml-1" data-dn-append-to="#edit-' + message.MessageKey + '" data-dn-button-label-closed="Edit" data-dn-button-label-open="Cancel" data-dn-parentkey="' + message.ParentKey + '" data-dn-messagekey="' + message.MessageKey + '" type="button" aria-expanded="false" aria-controls="edit-' + message.MessageKey + '"><i class="fas fa-pen"></i> <span>Edit</span></button>'
                            : ''
                        ) +

                        // Show the "Award Bounty" button to the author, if the bounty is open, and this isn't the author's message
                        ((dn.message.Current.IsBountyAuthor && (message.Author.UserKey !== dn.user.UserKey))
                            ? '<button class="btn btn-sm btn-success ml-1 dn-bounty-award-button"><span class="dnt-font font-weight-bold">Ð</span> <span>Award Bounty</span></button>'
                            : ''
                        ) +

                        '<div class="ml-2 d-flex justify-content-between align-items-center">\
                            <span class="d-none" id="data-' + message.MessageKey + '" data-currentvote="' + (message.UserVote 
                            || 0) + '" data-votetotal="' + message.Votes + '"></span>\
                            <button class="btn btn-vote btn-vote-up" data-vote="+1" id="' + message.MessageKey + '-upvote"><i class="' + ((message.UserVote && message.UserVote.Value == 1) ? "fas" : "fal") + ' fa-arrow-alt-up"></i></button>\
                            <div class="text-muted dn-vote-count" id="' + message.MessageKey + '-vote-count">' + voteText + '</div>\
                            <button class="btn btn-vote btn-vote-down" data-vote="-1" id="' + message.MessageKey + '-downvote"><i class="' + ((message.UserVote && message.UserVote.Value == -1) ? "fas" : "fal") + ' fa-arrow-alt-down"></i></button>\
                        </div>\
                    </div>\
                    <div class="mt-2 p-0 w-auto d-flex">\
                        <div class="ml-auto">\
                            <span class="dn-status-area">\
                                <span class="badge badge-pill dn-message-status dn-message-status-' + messageStatus + '">' + messageStatusNoun + '</span>' +

                                (!dn.message.Current.IsBountyAuthor
                                    ? '<span class="badge badge-pill badge-success dn-bounty-awarded-badge"><span class="dnt-font font-weight-bold">Ð</span>' + dn.message.Current.BountyAmount + ' Awarded</span>'
                                    : ''
                                ) +

                            '</span>\
                        </div>\
                        <div class="dn-tags clickable d-inline-block ml-2" id="dn-tags-' + message.MessageKey + '"><span class="dn-tag-icon"><i class="fas fa-tag fa-sm"></i></span>' +

                            tags +

                        '</div>\
                    </div>\
                </div>\
            </div>\
        </div>\
        <div id="reply-to-' + message.MessageKey + '" class="collapse dn-reply-box ml-2 mt-2 dn-depth-' + message.Depth + '"></div>' +

        (canEditReply
            ? '<div id="edit-' + message.MessageKey + '" class="d-none dn-edit-box ml-2 mt-2 dn-depth-' + message.Depth + '"></div>'
            : ''
        ));

        var $existingReply = $('div.dn-message[data-messagekey=' + message.MessageKey + ']');

        if ($existingReply.length)
        {
            // Already exists, likely an edited message, or for some reason it got loaded twice.
            // Just overwrite what's already there. 
            console.debug("insertReply", $newReply.find('*[data-selected="True"]'));
            dn.message.HighlightReply($newReply.find('*[data-selected="True"]'));
            $existingReply.replaceWith($newReply);
        }
        else
        {
            // Compute where to insert the reply. If this logic changes, make sure
            // to adjust the logic used in our MessageUpdate stored procedure as well.

            // First, get parent depth and sequence.
            var $parent = $('div.dn-message[data-messagekey=' + parentKey + ']');
            var parentSequence = parseInt($parent.data('sequence'));
            var parentDepth = parseInt($parent.data('depth'));

            // A reference to all replies.
            var $replies = $('.dn-reply');

            // Compute depth from parent: just increment by 1.
            var depth = parentDepth + 1;

            // If we don't find a sequence to insert at, we're going to insert at the end.
            var sequence = $replies.length + 1;

            // So we know if we've inserted this new reply or not.
            var inserted = false;

            console.debug("insertReply", "Parent Sequence/Depth", parentSequence, parentDepth);

            // Compute sequence from parent. Start by finding the sequence of the next 
            // message at the same or greater depth as this message's parent.

            // TODO: This could be optimized a bit if we use the pre-calculated sequence
            // and depth in the `message` data, though we still would need to loop through
            // all the messages after it and increase their sequence numbers. Or refactor
            // things to record a prev/next messagekey pointer to avoid having to know the
            // sequence number directly.

            $('.dn-reply').each(function(index)
            {
                var d = $(this).data('depth');
                var s = $(this).data('sequence');

                if (d <= parentDepth && s > parentSequence)
                {
                    if (!inserted)
                    {
                        sequence = s;

                        // Insert our new reply here
                        $(this).before($newReply);

                        // Flag it as inserted so further matches below our parent's sequence
                        // will just have their sequence incremented.
                        inserted = true;
                    }

                    // And increment the sequence for all the messages that
                    // come after our newly inserted reply. So that further
                    // inserts will work correctly.
                    $(this).data('sequence', s+1);
                }
            });

            if (!inserted)
            {
                // Insert this reply at the end.
                console.debug("insertReply", "Appending reply to the end of message block");
                $('.dn-message-block').append($newReply);
            }

            // Record our new sequence and depth info
            $newReply.data('sequence', sequence).data('depth', depth);

            console.debug("insertReply", "Computed", sequence, depth);
            console.debug("insertReply", "Actual", message.Sequence, message.Depth);

            if (sequence != message.Sequence)
            {
                console.error("insertReply", "Sequence mismatch (computed / actual): " + sequence + " / " + message.Sequence);
            }

            if (depth != message.Depth)
            {
                console.error("insertReply", "Depth mismatch (computed / actual): " + depth + " / " + message.Depth);
            }

            dn.message.ScrollToReply();
        }

        dn.compose.AddEventHandlers();
        dn.message.AddEventHandlers();
        dn.discussion.AddEventHandlers();
        dn.message.UnfurlLinks($newReply);
        dn.ConvertTimestamps();
    }

    /**
     * Internal function called when some element of the Add Bounty form changes, 
     * such as changing the number of tokens for the bounty, or the person's wallet
     * balance possibly updated, etc. Will enable/disable the "Add Bounty" button,
     * and show/hide the "Buy DNT" button as needed.
     */
    function updateBountyInfo(event)
    {
        var id = '#' + compose.AddBountyId;
        var numTokens = parseInt($(id + '-amount').val());
        var existingBounty = parseInt($(id).data('existing-bounty')) || 0;
        var newAmount = numTokens + existingBounty;

        $('.dn-bounty-add-amount').text(newAmount);

        if (numTokens > dn.token.Wallet.Balance)
        {
            // they don't have enough tokens, light up the Buy More button
            $('.' + dn.token.BuyTokensId).html('Buy&nbsp;&nbsp;' + dn.constants.TokenCurrencySymbolHtml + Math.ceil(numTokens - dn.token.Wallet.Balance));
            $('.dn-need-tokens').show();

            // and disable the Add Bounty button
            $('#dn-add-bounty-button').prop("disabled", true);
        }
        else
        {
            // they have enough tokens, de-emphasize the Buy More button
            $('.dn-need-tokens').hide();

            // and enable the Add Bounty button, as long as they're trying to add a +1 bounty or more
            $('#dn-add-bounty-button').prop("disabled", (numTokens < 1));
        }
    }

    /**
     * Show the "Add/Increase Bounty" modal popup.
     * 
     * @param {int}     existingBounty  - The number of tokens currently attached to this message, if any. If more than zero, we're increasing the bounty.
     * @param {bool}    isBountyOpen    - If it's not open, then the existing bounty amount is actually zero.
     * @param {func}    onAddBounty     - Callback that will be run when the "Add Bounty" button is clicked.
     */
    compose.AddBounty = function(existingBounty, isBountyOpen, onAddBounty, onClose) 
    {
        dn.agreement.Verify('Bounties', function() 
        {
            var title = 'Add Bounty';
            var label = 'Tokens';
            var opening = '<p>Bounties allow you to offer a financial incentive to receive more help, more quickly. Place \
                a bounty on your message in the form of ' + dn.constants.CommunityName + ' Tokens, called \
                ' + dn.constants.TokenCurrencyCode + ' or ' + dn.constants.TokenCurrencySymbolHtml + '. You will have two \
                weeks to award your bounty. You can increase your bounty later, if desired. <a href="/help#bounties" \
                target="' + dn.constants.LinkTargetNewWindow + '">Learn more about bounties.</a></p>';

            // Sometimes we may end up here with the Types box still open (like when calling compose.StartPost()),
            // so here we're going to make sure the dropdown has been closed up.
            if (compose.Selectize['dn-compose-Type'])
            {
                compose.Selectize['dn-compose-Type'].close();
            }

            var startingAmount = existingBounty + 1;
            var currentBountyValue = isBountyOpen ? existingBounty : 0;
            var buyAction = "add";
            var preposition = "of"; // used in the wording of the final button
            var startingTokens = 1; // The starting # of tokens to put in the Tokens box

            if (existingBounty)
            {
                if (isBountyOpen)
                {
                    title = 'Increase Bounty';
                    label = 'Additional Tokens';
                    buyAction = 'increase';
                    preposition = 'to';
                    opening = '<p>Increasing a bounty will elevate your message to the top of the Bounties page, \
                    notify everyone subscribed to Bounties or this discussion, and extend the time you have left to award \
                    the bounty to two weeks from today. <a href="/help#bounties" target="' + dn.constants.LinkTargetNewWindow + '">More about bounties.</a></p>';
                }
                else
                {
                    title = 'Reopen Bounty';
                    label = 'Tokens';
                    buyAction = 'reopen';
                    preposition = 'at';
                    startingTokens = startingAmount; // they must reopen at or above this amount
                    opening = '<p>Reopening a bounty will elevate your message to the top of the Bounties page, \
                    notify everyone subscribed to Bounties or this discussion, and extend the time you have left to award \
                    the bounty to two weeks from today. <a href="/help#bounties" target="' + dn.constants.LinkTargetNewWindow + '">More about bounties.</a></p> \
                    <p><b>NOTE:</b> Bounties can only be reopened above their previous value (' + dn.constants.TokenCurrencySymbolHtml + 
                    startingAmount + ' or higher in this case).';
                }
            }

            $('#' + compose.AddBountyId).remove();  // remove if it already exists
            $("body").append($('<div class="modal" tabindex="-1" role="dialog" style="display: none" id="' + compose.AddBountyId + '" data-existing-bounty="' + currentBountyValue + '">\
                <div class="modal-dialog" role="document">\
                    <div class="modal-content">\
                        <div class="modal-header">\
                            <h5 class="modal-title"><b>' + title + '</b></h5>\
                            <button type="button" class="close ' + compose.AddBountyId + '-close" data-dismiss="modal" aria-label="Close">\
                            <span aria-hidden="true">&times;</span>\
                            </button>\
                        </div>\
                        <div class="modal-body pb-0">\
                            ' + opening + '\
                            <div class="alert alert-danger" style="display: none" id="' + compose.AddBountyId + '-error" role="alert"></div>\
                            <label for="' + compose.AddBountyId + '-amount" class="dn-form-label">' + label + '</label>\
                            <div class="d-flex-block align-items-center mb-3 ml-0">\
                                <div class="input-group">\
                                    <div class="input-group-prepend">\
                                        <span class="input-group-text">' + dn.constants.TokenCurrencySymbolHtml + '</span>\
                                    </div>\
                                    <input type="number" id="' + compose.AddBountyId + '-amount" value="' + startingTokens + '" min="' + startingTokens + '" class="dn-token-amount form-control col-3 col-sm-2" aria-label="Bounty token value" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false"> \
                                </div>\
                            </div>\
                            <p class="mt-2 mb-3 dn-need-tokens" style="display: none"><button type="button" class="btn btn-success btn-sm ' + dn.token.BuyTokensId + ' py-0">Buy Tokens</button> to ' + buyAction + ' this bounty.</p>' +
                            (!existingBounty && dn.constants.BountyPromotionMaxDouble > 0 ? '<div class="alert alert-success py-1 px-2 d-inline-block" role="alert"><b>Promo:</b> We are doubling bounties through April! <a class="clickable" tabindex="0" role="button" data-toggle="collapse" aria-expanded="false" aria-controls="bounty-promo-description" href="#bounty-promo-description" onclick="$(this).hide()"><u style="color: #01603d">More info.</u></a><div class="collapse mt-1" id="bounty-promo-description">' + dn.constants.BountyPromotionDescription + '</div></div>' : '') +
                            '<p id="closing-modal"></p>\
                        </div>\
                        <div class="modal-footer d-flex">\
                            <div class="flex-grow-1 text-left"><span class="d-none d-sm-inline">Wallet </span>Balance <span class="dn-wallet-balance ml-0 font-weight-bold clickable">' + dn.constants.TokenCurrencySymbolHtml + '0</span></div>\
                            <button type="button" class="btn btn-secondary ' + compose.AddBountyId + '-close" id="' + compose.AddBountyId + '-cancel" data-dismiss="modal">Cancel</button>\
                            <button type="button" class="btn btn-primary dnt-in-sentence" id="' + compose.AddBountyId + '-button">' + title + ' ' + preposition + ' ' + dn.constants.TokenCurrencySymbolHtml + '<span class="dn-bounty-add-amount">' + startingAmount + '</span></button>\
                        </div>\
                    </div>\
                </div>\
            </div>'));

            // stop any spinners and close any open modals before showing our new one
            dn.Spin(false);

            var id = '#' + compose.AddBountyId;
            $(id).modal();

            // Code we want to run every time the bounty selection changes.
            $(id + '-amount').on('input', updateBountyInfo);

            // Add Bounty button clicked
            $(id + '-button').on("click", function(event) 
            {
                var numTokens = parseInt($(id + '-amount').val());
                onAddBounty(numTokens + currentBountyValue); // pass the total desired bounty amount
                $(id).modal('hide');
            });

            // Close button clicked
            $('.' + compose.AddBountyId + '-close').on("click", function(event) 
            {
                if (onClose)
                {
                    onClose();
                }
            });

            // Buy Tokens button clicked
            $('.' + dn.token.BuyTokensId).off('click').on("click", function(event) 
            {
                var numTokens = Math.ceil(parseInt($(id + '-amount').val()));

                dn.token.Buy
                (
                    (numTokens - dn.token.Wallet.Balance), 
                    function(tokens) 
                    {
                        dn.token.UpdateWalletBalance($('.dn-wallet-balance'), null, $(id + '-error'), updateBountyInfo);
                        $(id).modal('show'); // our Add Bounty dialog might be hidden
                    }, 
                    function() 
                    {
                        // closed without buying tokens, just update the balance anyway
                        dn.token.UpdateWalletBalance($('.dn-wallet-balance'), null, $(id + '-error'), updateBountyInfo);
                    }
                );
            });

            // If they click their current balance, reload their balance, and then set the bounty value to that amount.
            $('.dn-wallet-balance').on("click", function(e) 
            {
                dn.token.UpdateWalletBalance($('.dn-wallet-balance'), null, $(id + '-error'), function(e) 
                {
                    $(id + '-amount').val(dn.token.Wallet.Balance).change();
                    updateBountyInfo();
                });
            });

            $(id).modal('show');

            // select the text of the input for easier changes by the user
            $(id + '-amount').focus
            (
                function() 
                { 
                    window.setTimeout
                    (
                        function()
                        { 
                            console.debug("compose.AddBounty", "setTimeout", ".select()");
                            $(id + '-amount').select(); 
                        },
                        0
                    );
                }
            )
            .focus();

            dn.token.UpdateWalletBalance($('.dn-wallet-balance'), null, $(id + '-error'), updateBountyInfo);
        });
    };

    /**
     * Add event handlers related to composing messages once the page have been rendered. 
     * This can be called multiple times, such as after dynamically inserting new
     * replies, because we add `dn-event-{event}` classes to each element that we
     * attach an event handler to, so that we don't worry about doing it twice.
     */
    compose.AddEventHandlers = function()
    {
        console.debug("compose.AddEventHandlers");

        $('.dn-compose-button:not(.dn-event-click)')
        .click(dn.compose.HandlePostButtonClick)
        .addClass("dn-event-click");

        $(".dn-edit-button:not(.dn-event-click)")
        .each(function (key, value) 
        {
            $(value)
            .on("click", function () 
            {
                dn.compose.MessageEditsInProgress.push($(value).data("dn-messagekey"));
            })
        })
        .addClass('dn-event-click');
    };

    /**
     * Award a bounty to a user for a specific message.
     * 
     * @param {string}  messageKey  - The MessageKey of the message being designated in the bounty award.
     * @param {string}  amount      - The amount of the bounty, formatted for display.
     * @param {string}  recipient   - The name of the person being awarded the bounty.
     */
    compose.AwardBounty = function (messageKey, amount, recipient) 
    {
        dn.ShowModal
        (
            {
                title: "Award Bounty to " + recipient,
                body: 'Please confirm bounty award of <span class="dnt-in-sentence">' + dn.constants.TokenCurrencySymbolHtml + amount + '</span> to ' + recipient + '.',
                buttonText: 'Award Bounty of <span class="dnt-in-sentence">' + dn.constants.TokenCurrencySymbolHtml + amount + '</span>',
                buttonClass: 'btn-success',
                onButtonClick: function (e) 
                {
                    $(e.target).attr('disabled', true); // disable button to avoid multi-click activity
                    $.postJSON("/api/v1/message/" + messageKey + "/bounty/award")
                    .done
                    (
                        function () 
                        {
                            location.replace(window.location.toString().split("?")[0] + "?m=" + messageKey);
                        }
                    )
                    .fail
                    (
                        function (xhr, textStatus, errorThrown) 
                        {
                            if (!dn.IsErrorHandledAutomatically(null, xhr, null, errorThrown)) 
                            {
                                var body = dn.FormatApiError(xhr.responseJSON);
                                dn.ShowModal({ title: "Error Awarding Bounty", body: body });
                            }
                        }
                    );
                }
            }
        );
    };

    /**
     * Pops up a confirmation box confirming they wish to cancel their message edit.
     * This is crucial because we don't currently save status on edits.
     */
    compose.CancelEdit = function (messageKey) 
    {
        var title = "Cancel Message Edit";
        var body = "<p>Are you sure you want to discard these changes?</p>";
        dn.ShowModal
        (
            {
                title: title,
                body: body,
                buttonText: 'Discard Changes',
                buttonClass: 'btn-danger',
                onButtonClick: function (e) 
                {
                    var $btn = $("[data-dn-append-to='#edit-" + messageKey + "']");
                    $btn.closest(".dn-message").show(); // re-display original message
                    $btn.click(); // close edit form

                    for (var i = compose.MessageEditsInProgress.length - 1; i >= 0; i--) 
                    {
                        if (compose.MessageEditsInProgress[i] === messageKey) 
                        {
                            compose.MessageEditsInProgress.splice(i, 1);
                        }
                    }

                    $('.modal').modal('hide');
                }
            }
        );
    };

    /**
     * Embed the given files in the form.
     *
     * Note: we also do this in two other places: on the on the discussion thread page (generated server-side)
     * and on the homepage (in a vuejs template). If you change this, you should consider changing it in those
     * other places too.
     *
     * @param {element} element - The element we should append files to.
     * @param {object} files - The array of File objects that should be shown.
     */
    compose.EmbedFiles = function($form)
    {
        var messageKey = $form.data("messagekey");
        var parentKey = $form.data("parentkey");
        var fileKeys = compose.FileKeys['files' + parentKey];
        var fileTypes = compose.FileTypes['files' + parentKey];
        var $attachments = $form.find(".dn-attachments");

        if (fileKeys && fileKeys.length > 0)
        {
            $.each(fileKeys, function(index, fileKey) 
            {
                // Only add files one time, no matter how many times we call this method.
                if ($('#' + fileKey).length <= 0)
                {
                    var embedFile = null;
                    var fileType = parseInt(fileTypes[index]);

                    if ((fileType & dn.constants.FileTypes.Image) != 0)
                    {
                        // image
                        embedFile = 'data-src="/file/' + fileKey + '/lg"';
                    }
                    else
                    {
                        // something other than image (use /embed)
                        embedFile = 'data-type="iframe" data-src="/file/' + fileKey + '/embed"';
                    }

                    var $image = $('<div id="' + fileKey + '" data-fancybox-trigger="gallery-edit-' + messageKey + '" ' + embedFile + ' data-filetype="' + fileType + '" class="dn-file-wrapper d-inline-block' + (fileType == 32 ? ' video-thumbnail-overlay' : '') + '" ondragstart="dn.compose.DragEvent = event;"><img src="/file/' + fileKey + '/sm" class="img-fluid mh-100 rounded"/></div>');

                    $image.on("click", function(e) 
                    {
                        e.preventDefault();
                        $image.contextMenu({ x: e.pageX, y: e.pageY });
                        // or image.contextMenu();
                        // or image.trigger("contextmenu");
                    });

                    // hijack both left and right click on attached file thumbnail to enable various functions
                    $.contextMenu
                    (
                        {
                            selector: '#' + $image.attr('id'),
                            callback: function (key, options) 
                            {
                            },
                            items: 
                            {
                                // insert file url into post
                                "embed": 
                                {
                                    name: 'Embed File',
                                    isHtmlName: true,
                                    callback: function (itemKey, opt, e) 
                                    {
                                        var url = dn.constants.BaseHref + "/file/" + $(opt.$trigger).attr("id").replace("display-", "");

                                        if (dn.constants.UseRichTextEditor) 
                                        {
                                            if (true || compose.LastEditor && compose.LastEditor.model.document.selection.getLastPosition().path[0] == 0 && compose.LastEditor.model.document.selection.getLastPosition().path[1] == 0) 
                                            {
                                                // no cursor set yet, append to bottom of message
                                                var body = (compose.LastEditor.getData() || "").replace(dn.constants.RegEx.EmptyParagraphs, '') + ('<p><a href="' + url + '">' + url + '</a> &#8203;</p>');
                                                compose.LastEditor.setData(body);
                                            } 
                                            else
                                            {
                                                // user has set the cursor somewhere - insert there
                                                // TODO: get this working with surrounding line breaks https://github.com/ckeditor/ckeditor5/issues/1424
                                                compose.LastEditor.model.change(function (writer) 
                                                {
                                                    var insertPosition = compose.LastEditor.model.document.selection.getLastPosition();
                                                    var linkedText = writer.createText(url, { linkHref: url });
                                                    compose.LastEditor.model.insertContent(linkedText, insertPosition);
                                                });
                                            }
                                        } 
                                        else if (compose.LastEditor)
                                        {
                                            var body = (compose.LastEditor.val() || "");

                                            var trailingLineBreak = "\n\n";
                                            var bodyHasTrailingLineBreak = body.indexOf(trailingLineBreak, body.length - trailingLineBreak.length) !== -1;

                                            if (!bodyHasTrailingLineBreak) 
                                            {
                                                body += trailingLineBreak;
                                            }

                                            body += url;

                                            compose.LastEditor.val(body);
                                        }
                                    }
                                },
                                "copy": // copy the url of the file details page for the clicked attached file
                                { 
                                    name: 'Copy Link',
                                    isHtmlName: true,
                                    callback: function (itemKey, opt, e) 
                                    {
                                        var $copy = $(opt.$menu[0]); // $menu[0] -> copy was clicked

                                        // use clipboard.js to set up "copy to clipboard" if not already done
                                        if (!$copy.attr("data-clipboard-text")) 
                                        {
                                            $copy.attr("id", opt.$trigger[0].id + "-copy");
                                            $copy.attr("data-clipboard-text", dn.constants.BaseHref + "/file/" + $(opt.$trigger).attr("id").replace("display-", ""));
                                            var clipboard = new ClipboardJS("#" + $copy.attr('id'));
                                        }
                                    }
                                },
                                "view":   // preview file
                                {
                                    name: 'View File',
                                    isHtmlName: true,
                                    callback: function (itemKey, opt, e) 
                                    {
                                        // For in-progress videos, show a modal dialog to help the user understand what's going on. 
                                        // For all others, show the file in our overlay/carousel.
                                        dn.ShowFileInGallery($(this), "<p>You can post the message whenever you're ready, and we'll finish processing the video as quickly as possible.</p>");
                                    }
                                },
                                "delete":   // delete file
                                {
                                    name: 'Remove File',
                                    isHtmlName: true,
                                    callback: function (itemKey, opt, e) 
                                    {
                                        compose.RemoveFile($form, fileKey);
                                    }
                                }
                            }
                        }
                    );

                    $attachments.find(".dn-compose-upload").before($image);
                }
            });
            $attachments.addClass("has-attachments");
        }
        else
        {
            $attachments.removeClass("has-attachments");
        }
    };

    /**
     * Fill in the current form with their latest message details. This is usually
     * called when the form is first being displayed (either created from scratch and
     * displayed, or just filled in again and un-hidden).
     * 
     * @param {element} $form                   - The form we want to fill these values into.
     * @param {object}  messageKey              - The MessageKey of the message being worked on.
     * @param {bool}    typeManagerStatusEditor - True if this user is a type manager approved to change message status, 
     *                                            NOT the author of the root message. We use this knowledge when deciding 
     *                                            whether to show them the option to set a Status, as well as in how we 
     *                                            display the status options to them.
     */
    compose.FillForm = function($form, messageKey, typeManagerStatusEditor)
    {
        var msg = compose.Messages[messageKey] || {};

        if (!compose.FilledForms[messageKey])
        {
            console.debug("compose.FillForm", "Executed", msg.TypeId, messageKey);

            // Save this status so we don't try to re-fill it again later if they change the type
            compose.FilledForms[messageKey] = true;

            var parentKey = msg['ParentKey'] || '';

            // Setup the title field: first clear any title listeners, then set
            // the title, then call SetupTextFields to attach new event listeners.
            var $title = $form.find(".dn-compose-Title");
            $title.off("keydown paste cut input");  // Re: https://github.com/dennyferra/TypeWatch/issues/36#issuecomment-722637558
            $title.val(msg.Title);
            compose.SetupTextFields($title, $form);

            // the body of the message
            compose.FillFormBody($form, msg);

            // any files
            compose.EmbedFiles($form);

            // type info
            compose.ShowTypeInfo($form, parentKey, msg.TypeId);

            // message status, if found, otherwise default to the default status for this type
            $form.find('.dn-compose-message-status').val(msg.Status || 0);

            // Show helpful info below the reply type selection dropdown
            $form.find('.dn-compose-message-status').off('change').change(function(event) 
            {
                $(this).closest('.dn-compose-edit-box.dn-message-status').find('.dn-message-status-help').html(dn.message.StatusExplanation[$(this).val()].replaceAll('{0}', dn.constants.DiscussionTypes[msg.TypeId].Name));
            });

            // Trigger the change event so we can show the currently selected help info.
            $form.find('.dn-compose-message-status').change();
        }
        else
        {
            console.debug("compose.FillForm", "Ignored", msg.TypeId, messageKey);

            // the body of the message
            compose.FillFormBody($form, msg);
        }
    };

    /**
     * Put the cursor focus in the most applicable spot.
     * 
     * @param {element} $form - The form we want to fill these values into.
     * @param {object} msg - The message that the person was working on, if any.
     */
    compose.Focus = function($form, msg)
    {
        // If no modal is being shown (such as "Add Bounty" modal), set the focus of the form...
        if ($(".modal:visible").length === 0)
        {
            // figure out where to put the focus
            if (msg.ParentKey)
            {
                // this is a reply
                $form.find(dn.constants.EditorSelector).first().focus();
            }
            else
            {
                var id = $form.attr('id');
                var typeKey = id + "-Type";
                var topicsKey = id + "-Topics";

                if ($form.find(".dn-compose-Title").val() == "")
                {
                    $form.find(".dn-compose-Title").focus();
                }
                else if (dn.compose.Selectize[typeKey].getValue() === "")
                {
                    if (!$('div.modal').hasClass('show'))    // don't give focus if a modal is present (such as "Add Bounty")
                    {
                        dn.compose.Selectize[typeKey].focus();
                    }
                }
                else if (dn.compose.Selectize[topicsKey].getValue() === "")
                {
                    if (!$('div.modal').hasClass('show'))    // don't give focus if a modal is present (such as "Add Bounty")
                    {
                        dn.compose.Selectize[topicsKey].focus();
                    }
                }
                else
                {
                    $form.find(dn.constants.EditorSelector).first().focus();
                }
            }
        }
    };

    /**
     * This creates the <form> to be used for the post or reply, or if it was previously created
     * for the given toggling button, fills the form in with the contents of the given msg, and returns it.
     * 
     * @param {element} $button     - The button element that triggered the display of the form.
     * @param {object}  messageKey  - The MessageKey of the Message object to use to setup this form.
     * @param {object}  typeManager - Possible TypeManager object, if the current message editor is a 
     *                                manager of this message type. Otherwise, null.
     */
    compose.GetForm = function($button, messageKey, typeManager) 
    {
        var msg = compose.Messages[messageKey] || {};
        var parentKey = msg.ParentKey || '';
        var isCompleted = (msg.DateCompleted || false);
        var $appendTo = $($button.data('dn-append-to'));
        var id = 'dn-compose' + parentKey;
        var $form = $appendTo.find('#' + id);
        var isInitialSetup = !($form && $form.length > 0);

        var $rootMessage = $('.dn-root-message');
        var $message = $button.closest(".dn-message"); // the wrapping message they are replying to or editing

        var rootUserKey = $rootMessage.data('userkey');
        var rootTypeId = (msg.TypeId || $rootMessage.data('type-id') || 0);
        var type = dn.constants.DiscussionTypes[rootTypeId];
        var isBot = ($message.data("isbot") === "True");

        // The author UserKey of the person that wrote the message being replied to. This is only
        // going to be set on the Reply button, so if we get here via an edit button, it's empty.
        var selectedUserKey = $message.data('userkey');

        // setup our files that have already been attached
        compose.FileKeys['files' + parentKey] = msg.FileKeys;
        compose.FileTypes['files' + parentKey] = msg.FileTypes;

        var editingReplyByOriginalPoster = (isCompleted && rootUserKey === selectedUserKey);

        // Find out if this user is an editing type manager, NOT the author of the root message. We
        // use this knowledge when deciding whether to show them the option to set a Status, as well
        // as in how we display the status options to them.
        var isOriginalPoster = (rootUserKey === dn.user.UserKey);
        var typeManagerStatusEditor = (!isOriginalPoster && typeManager && typeManager.CanEditMessageStatus);

        if (!isInitialSetup)
        {
            // form was already created previously, just fill it in with data,
            // then make sure it's visible.
            console.debug("compose.GetForm", id, $form, "Found form, filling in with new message data.");
            compose.FillForm($form, messageKey, typeManagerStatusEditor);
        }
        else
        {
            console.debug("compose.GetForm", id, $form, "No existing form, creating new one with message data.");

            var now = parseInt(Date.now() / 1000);
            var dateCompleted = $message.find('.dn-datecompleted').data('timestamp');
            var secondsSincePosted = now - dateCompleted;
            var canClose = (isOriginalPoster || typeManagerStatusEditor) && $rootMessage.data('is-closeable') === 'True';

            var messageStatusOptions = '';

            if ((isOriginalPoster || typeManagerStatusEditor) && type)
            {
                type.AllowedStatuses.forEach
                (
                    function (status)
                    {
                        if ((parentKey && dn.message.StatusNotOnReplies[status]) || (!typeManagerStatusEditor && dn.message.StatusTypeManagersOnly[status]))
                        {
                            // Skip any options that are being used on a reply and aren't allowed on replies,
                            // or should only be visible to TypeManagers, like "Rejection".
                            return;
                        }

                        messageStatusOptions += '<option value="' + status + '">' + dn.message.StatusDropdown[status] + '</option>';
                    }
                );
            }

            // form has not yet been created, so create it and append it to the given element.
            $form = $('<div id="' + id + '" data-type-id="' + rootTypeId + '" data-parentkey="' + parentKey + '" data-messagekey="' + messageKey + '" class="dn-compose-form' + (parentKey ? " dn-compose-reply" : "") + (isCompleted ? " dn-compose-edit" : "") + '">' +  

                // Error Display
                '<div class="mt-2 mr-' + (parentKey ? '5' : '0') + ' alert alert-danger alert-dismissible fade show dn-compose-error" style="display: none" role="alert">\
                    <span class="dn-compose-error-message" id="dn-compose-' + parentKey + '-error"></span>\
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close">\
                    <span aria-hidden="true">&times;</span>\
                    </button>\
                </div>' +

                // Start of Form
                '<form>\
                    <div class="form-row pr-0 mr-0 ' + (parentKey ? 'mt-0' : 'mt-2') + ' pl-0">' +

                        (parentKey 

                            // Reply, and not editing a reply.
                            ? (selectedUserKey === dn.user.UserKey && !isCompleted

                                // This person is replying to their own message. 
                                ? (secondsSincePosted < dn.constants.WarnEditInsteadOfReplySeconds

                                    // Not much time has passed, ask them if they'd rather edit their original message instead.
                                    ? '<div class="alert alert-warning p-2 my-1"><i class="fas fa-exclamation-triangle mr-1"></i> If you are trying to update or correct your original message, consider editing it instead of replying to it.</div>'

                                    // Don't bother showing a warning since "too much" time has passed, and they should reply instead.
                                    : ''
                                )

                                // Replying to someone else's message
                                : ''
                            )

                            // New Discussion
                            : 

                            // Title
                            '<div class="form-group col-12 pr-0">\
                                <div class="input-group">\
                                    <div class="input-group-prepend">\
                                        <label class="input-group-text px-1" for="dn-compose-Title' + parentKey + '">Title</label>\
                                    </div>\
                                    <input class="form-control dn-compose-Title" autocomplete="off" id="dn-compose-Title' + parentKey + '" type="text"  placeholder="Summarize your message">\
                                </div>\
                                <div class="invalid-feedback mx-1 mx-sm-0" id="dn-compose-Title' + parentKey + '-error"></div>\
                            </div>' +

                            // Type
                            '<div class="dn-compose-Type-wrapper form-group col-12 col-xl-auto pr-0 pr-xl-1">\
                                <div class="input-group dn-compose-Type' + parentKey + '">\
                                    <div class="input-group-prepend">\
                                        <label class="input-group-text px-1" for="dn-compose-Type' + parentKey + '">Type</label>\
                                    </div>\
                                    <input autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" class="form-control dn-compose-Type dn-autosuggest-field" id="dn-compose-Type' + parentKey + '" data-role="tagsinput" type="text" placeholder="Type of message">\
                                </div>\
                                <div class="invalid-feedback mx-1 mx-sm-0" id="dn-compose-Type' + parentKey + '-error"></div>\
                            </div>' + 

                            // To 
                            '<div class="form-group col-12 col-xl pr-0">\
                                <div class="input-group dn-compose-Topics' + parentKey + '">\
                                    <div class="input-group-prepend">\
                                        <label class="input-group-text px-1" for="dn-compose-Topics' + parentKey + '">To</label>\
                                    </div>\
                                    <input autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" class="form-control dn-compose-Topics dn-autosuggest-field" id="dn-compose-Topics' + parentKey + '" data-role="tagsinput" type="text" placeholder="Topics or User Groups">\
                                </div>\
                                <div class="invalid-feedback mx-1 mx-sm-0" id="dn-compose-Topics' + parentKey + '-error"></div>\
                            </div>' +

                            // Topic and Type info
                            '<div class="mt-0 alert alert-info fade show dn-compose-info" style="display: none" role="alert">\
                                <span class="dn-compose-info-message" id="dn-compose-' + parentKey + '-info"></span>\
                            </div>' +

                            // Metadata placeholder
                            '<div class="dn-compose-Metadata form-row"></div>'

                        ) + // END OF NEW-DISCUSSIONS-ONLY FIELDS

                        (
                            // Show a warning if it looks like they might be editing when they should be replying to update/delay/resolve
                            (canClose && isCompleted && secondsSincePosted > dn.constants.WarnReplyInsteadOfEditSeconds)
                                ? '<div class="alert alert-warning p-2 my-1"><i class="fas fa-exclamation-triangle mr-1"></i> If you are trying to close this <i>' + type.Name + '</i> or update participants on the status, please reply to your original message and choose the appropriate message status, rather than editing this message. <a href="/help#asking-for-help">Learn more.</a></div>'
                                : ''
                        ) +


                        (
                            // Potentially warn people if replying to the bot.
                            (parentKey && isBot)
                                ? dn.constants.BotReplyWarningHtml
                                : ''
                        ) +

                        // Body (CKEditor or text input for CKEditor unsupported browsers)
                        '<div class="form-group col-12 pr-0">\
                            <div class="dn-body-wrapper"></div>\
                        </div>' +

                        // Attaching Files and Metadata
                        '<div class="col-12 dn-attachments mt-2 mr-0 flex-wrap d-flex align-items-stretch" id="dn-attachments' + parentKey + '"><button type="button" class="btn dn-button d-inline-block mr-1 mb-1 dn-compose-upload" id="dn-compose-upload' + parentKey + '"><i class="fal fa-paperclip"></i> Attach Files</button><button type="button" class="btn dn-button d-none mr-1 mb-1 dn-compose-add-metadata" data-toggle="collapse" data-target="#dn-compose-Metadata' + parentKey + '" id="dn-compose-add-metadata' + parentKey + '"><i class="fal fa-plus"></i> <span>Show Metadata</span></button></div>' +

                        ((parentKey && (isOriginalPoster || (typeManagerStatusEditor && editingReplyByOriginalPoster)))

                            // Let replies from the OP attach metadata
                            ? '<div class="dn-compose-Metadata form-row collapse" id="dn-compose-Metadata' + parentKey + '"></div>'

                            : ''
                        ) +

                        // Let them set message status (update/delay/resolution), if:
                        // 
                        // - This is a reply
                        // - This is the author of the entire discussion OR a type manager with `CanEditMessageStatus` option enabled
                        // - The root message "is closeable", i.e. is a bounty or question
                        ((canClose && parentKey)

                            // Person replying to their own question/bounty (or something else "closeable"), so let them define what kind of reply this is.
                            // This is where they can essentially close their message by specifying that this reply is the resolution to their question.
                            ? '<div class="rounded alert alert-secondary dn-compose-edit-box dn-message-status mt-2 mb-2 p-2">\
                                <p><b>What kind of reply is this?</b></label>' +

                                (
                                    typeManagerStatusEditor
                                    ? '<p class="mb-2">Since you\'re a manager of the <i>' + type.Name + '</i> message type, you can choose a non-Default reply status to adjust the overall status of this conversation.</p>'
                                    : '<p class="mb-2">Since you\'re replying to your own <i>' + type.Name + '</i>, you can choose a reply status.</p>'
                                ) +

                                '<div class="input-group col-4 pl-0">\
                                    <select class="custom-select dn-compose-message-status" id="dn-compose-message-status' + messageKey + '">' +
                                        messageStatusOptions +
                                    '</select>\
                                </div>\
                                <p class="dn-message-status-help mt-2 text-muted text-small"></p>\
                            </div>'

                            // Person not replying to their own message (or editing that reply), or it's not closeable, so don't do anything special.
                            : ''
                        ) +

                        (isCompleted

                            // Editing, show a box to let the user summarize their changes, and another asking if they want to notify participants 
                            ? '<div class="rounded alert alert-secondary dn-compose-edit-box dn-editor-notes mt-2 mb-2 p-2" style="display: none">\
                                <p><b>Why are you editing this message?</b> (Optional)</p>\
                                <p>This field is intended to let you briefly explain <i>why</i> you\'re editing the message. This may be shown with the \
                                revision history, and sent to participants in this discussion if you choose to notify them, but most people will not see this.</p>' +

                                (canClose ? '<p><b>Don\'t use this field to provide an update on your status.</b> Instead, reply to the original message.</p>' : '') +

                                '<div class="form-group col-12 px-0 mb-1">\
                                    <div class="input-group">\
                                        <input class="form-control dn-compose-EditorNotes" maxlength="140" autocomplete="off" id="dn-compose-EditorNotes' + parentKey + '" type="text"  placeholder="Briefly explain why you are editing your message.">\
                                    </div>\
                                    <div class="invalid-feedback mx-1 mx-sm-0" id="dn-compose-EditorNotes' + parentKey + '-error"></div>\
                                </div>\
                                <div class="mt-2">\
                                    <input type="checkbox" id="dn-compose-EditorNotesNotify' + parentKey + '">\
                                    <label for="dn-compose-EditorNotesNotify' + parentKey + '">Notify participants that you edited this message</label>\
                                </div>\
                            </div>'

                            // Not editing, must be replying
                            : ''
                        ) + 

                        // Signature and Post button
                        '<div class="form-group col-12 pr-0 mt-2">\
                            <div class="media dn-signature">\
                                <img alt="" src="' + msg.Author.UrlProfilePhoto + '" class="avatar avatar-sm avatar-square" />\
                                <div class="media-body">\
                                    <div class="dn-sig-name">' + dn.text.QuoteAttribute(msg.Author.FirstName + ' ' + msg.Author.LastName) + '</div><div class="dn-sig-position">' + (msg.Author.Position || '') + '</div>\
                                    <div class="dn-sig-business-location">' + (msg.Author.BusinessName ? '<div class="dn-sig-business">' + dn.text.QuoteAttribute(msg.Author.BusinessName) + '</div><div class="dn-sig-separator">&#160;in&#160;</div>' : '') + '<div class="dn-sig-location">' + dn.text.QuoteAttribute(msg.Author.BusinessCity + ', ' + msg.Author.BusinessLocation) + '</div></div>\
                                </div>\
                                <div class="media-body ml-1">' +
                                    (isCompleted ? '<button type="button" class="btn btn-danger btn-cancel-edit mb-1" data-dn-current-status="open" onclick="dn.compose.CancelEdit(\'' + msg.MessageKey + '\');">Cancel</button>' : '') + '\
                                    <button type="button" class="btn btn-post dn-compose-post mb-1">' + (isCompleted ? 'Save Changes' : 'Post') + (isCompleted ? '' : ('<span class="dn-post-type d-md-inline d-none">&nbsp;' + (parentKey ? 'Reply' : 'Message') + '</span>')) + '</button>\
                                    <span class="dn-compose-saving ml-1 text-muted" style="display: none"><span class="dn-saving-small"><i class="fal fa-sync fa-spin"></i></span><span class="dn-saving-large d-md-inline d-none ml-1">Saving</span></span>\
                                </div>\
                            </div>\
                        </div>\
                    </div>\
                </form>\
            </div>');

            compose.InitFileUploader(/*function() {
                const makeDropPane = (container, opts) => {
                    const options = {
                      container, // can be CSS selector string or DOM node
                      displayMode: 'dropPane',
                      dropPane: {
                        overlay: false, // if this is true then overlays will conflict between instances
                        onSuccess: function (res) { console.debug(res) },
                      },
                    };
                    client.picker(options).open();
                  };

                  [ 'droppane1',
                    'droppane2',
                    'droppane3',
                    'droppane4',
                  ].forEach(function (id) {
                    makeDropPane(id);
                  });
            }*/);

            if (!parentKey)
            {
                if (msg.Bounty && msg.Bounty.BountyId)
                {
                    // Save bounty data in the form
                    $form.data("bounty", msg.Bounty);

                    // just in case they somehow have a bounty attached but the type got changed to something else
                    msg.TypeId = dn.constants.BountyTypeId;
                    $form.data("type-id", dn.constants.BountyTypeId);
                }
                else
                {
                    $form.data("bounty", {});
                }

                var typeOptions = dn.user.IsAdministrator
                    // show all non-IsChat types to administrators
                    ? $.grep(Object.keys(dn.constants.DiscussionTypes).map(function(typeId){return dn.constants.DiscussionTypes[typeId]}), function(item, index) { return !item.IsChat })
                    // show only non-IsAdminOnly/non-IsChat types (just for UX purposes... admin status still confirmed server-side)
                    : $.grep(Object.keys(dn.constants.DiscussionTypes).map(function(typeId){return dn.constants.DiscussionTypes[typeId]}), function(item, index) { return (!item.IsAdminOnly && !item.IsChat) });

                // AUTOSUGGESTIONS for Type
                compose.Selectize[id + '-Type'] = $form.find('#dn-compose-Type').selectize({
                    loadThrottle: null,
                    valueField: "TypeId",
                    searchField: "Name",
                    // these next two lines pre-fill any existing types
                    options: typeOptions,
                    items: msg.TypeId ? [msg.TypeId] : [],
                    // optgroupField: "IsPopular",
                    // lockOptgroupOrder: true,
                    // optgroups: compose.TypeOptionGroups,
                    sortField: [
                        {
                            field: 'Name',
                            direction: 'asc'
                        },
                        {
                            field: '$score'
                        }
                    ],
                    persist: true,
                    hideSelected: true,
                    selectOnTab: true,
                    onDropdownOpen: function($dropdown)
                    {
                        // Don't automatically highlight the first item when we open
                        var self = this;
                        setTimeout(function()
                        {
                            if (self.$activeOption)
                            {
                                self.$activeOption.removeClass('active');
                                self.$activeOption = null;
                            }
                        }, 0);
                    },
                    create: false,
                    plugins: ['remove_button', 'restore_on_backspace'],
                    mode: 'multi',
                    highlight: false,
                    maxItems: 1,
                    openOnFocus: true,
                    closeAfterSelect: true,
                    onInitialize: function(element)
                    {
                        var typeId = this.getValue();

                        if (typeId)
                        {
                            var type = dn.constants.DiscussionTypes[typeId];

                            if (typeId == dn.constants.BountyTypeId && msg.Bounty && (msg.Bounty.IsOpen || !msg.Bounty.AwardedMessageKey))
                            {
                                // Add onClick handler for the bounty type box, to let them increase the bounty.
                                $form.find('.dn-type-bounties').on("click", function(e) 
                                { 
                                    addBounty($form); 
                                });
                            }
                            else if (type.InitialStatuses.length > 0)
                            {
                                $form.find('.dn-type-' + type.TypeKey).on('click', function(e) 
                                {
                                    if (!$(e.target).hasClass("remove"))
                                    {
                                        compose.SetInitialStatus($form, type); 
                                    }
                                });
                            }

                            // Initialize with any existing data-message-status, or if that's not set,
                            // then the message's `Status` property.
                            $form.data('message-status', (typeof $form.data('message-status') !== "undefined" ? $form.data('message-status') : msg.Status));
                        }
                    },
                    onItemAdd: function (typeId, element) 
                    {
                        // add the type
                        if (typeId == dn.constants.BountyTypeId && !$form.data("bounty").Amount)
                        {
                            // They are setting the message type to Bounty, but they have not 
                            // yet set the bounty up, so drop the type box (temporarily) and show the Add Bounty modal.
                            compose.Selectize[id + '-Type'].clear(true); // using `clear` instead of `removeItem` prevents compose.Save() from being called here, which is good

                            // Open the "Add Bounty" handler
                            addBounty($form);
                        }
                        else
                        {
                            // Non-bounty type, or bounty has already been paid, just add the box and possibly show type info
                            setTimeout
                            (
                                // Wait until we've left this callback before saving, otherwise we may 
                                // not actually "see" the value saved yet.
                                function()
                                {
                                    compose.Save($form, false);
                                },
                                20
                            );

                            compose.ShowTypeInfo($form, parentKey, typeId);

                            if (dn.constants.DiscussionTypes[typeId].InitialStatuses.length > 0)
                            {
                                $form.find('.dn-type-' + dn.constants.DiscussionTypes[typeId].TypeKey).on("click", function(e) 
                                {
                                    if (!$(e.target).hasClass("remove"))
                                    {
                                        compose.SetInitialStatus($form, dn.constants.DiscussionTypes[typeId]); 
                                    }
                                });

                                // They've chosen a message type that allows the author to set the initial status, ask them what it should be.
                                compose.SetInitialStatus($form, dn.constants.DiscussionTypes[typeId]);
                            }
                        }

                        // Clear any errors that were there
                        $form.find(".input-group." + id + '-Type').removeClass("is-invalid");
                        $form.find("#" + id + '-Type-error').text("").hide();

                        var previousTypeId = $form.data("type-id");
                        $form.data("type-id", typeId);

                        if (previousTypeId != typeId)
                        {
                            // Type is being changed, clear the message status and the render cache
                            $form.data('message-status', dn.constants.DiscussionTypes[typeId].DefaultStatus);
                            compose.Selectize[id + '-Type'].clearCache(typeId); // clear the render cache for this item
                            compose.Selectize[id + '-Type'].updateOption(typeId, compose.Selectize[id + '-Type'].options[typeId]);

                            // Updating body and metadata fields based on this type
                            compose.UpdateBodyAndMetadata($form, msg, typeManagerStatusEditor, false);

                            // Set the topics based on type (potentially), and then validate them.
                            dn.compose.Selectize["dn-compose-Topics"].clearOptions(true); 
                            dn.compose.Selectize["dn-compose-Topics"].addOption(dn.compose.GetTopics($form, msg));
                            dn.compose.Selectize["dn-compose-Topics"].refreshOptions(false);
                            compose.ValidateTopics($form);
                        }
                    },
                    onCanItemRemove: function(typeId, $item, onCanRemove)
                    {
                        console.log("onCanItemRemove", typeId, $item, $form);

                        if (typeId == dn.constants.BountyTypeId && $form.data("bounty").Amount)
                        {
                            // They are trying to remove the Bounty type, but the message has a Bounty set, so we stop it.
                            dn.ShowModal
                            ({
                                title: 'Type Cannot Be Changed',
                                body: 'A bounty has been added to this message, so the message type cannot be changed.'
                            });
                        }
                        else if (dn.constants.DiscussionTypes[typeId].IsCloseable && (typeof $form.data('message-status') !== "undefined" ? $form.data('message-status') : msg.Status) >= dn.constants.StatusResolved)
                        {
                            // They are trying to remove a closeable message type that has been resolved, don't let them.
                            dn.ShowModal
                            ({
                                title: 'Type Cannot Be Changed',
                                body: 'This <i>' + dn.constants.DiscussionTypes[typeId].Name + '</i> has been resolved, so the message type cannot be changed.'
                            });
                        }
                        else
                        {
                            // they CAN remove it!
                            onCanRemove();
                        }
                    },
                    onItemRemove: function (typeId) 
                    {
                        // remove the type
                        var saveTimeout = setTimeout
                        (
                            // Wait until we've left this callback before saving, otherwise we may 
                            // not actually "see" the value saved yet.
                            function()
                            {
                                compose.Save($form, false);
                            },
                            20
                        );

                        compose.ShowTypeInfo($form, parentKey, null);

                        // Set the topics based on type (potentially), and then validate them.
                        dn.compose.Selectize["dn-compose-Topics"].clearOptions(true); 
                        dn.compose.Selectize["dn-compose-Topics"].addOption(dn.compose.GetTopics($form, msg));
                        dn.compose.Selectize["dn-compose-Topics"].refreshOptions(false);
                        compose.ValidateTopics($form);
                    },
                    render: 
                    { 
                        optgroup_header: function(data, escape) 
                        {
                            if (data.label)
                            {
                                return '<div class="type-optgroup-header">' + escape(data.label) + '</div>';
                            }
                            else
                            {
                                return '<div style="display: none"></div>';
                            }
						},
                        option: function (data, escape) 
                        {
                            return '<div class="dn-metadata-choice"><span class="type-name">' + escape(data.Name) + '</span></div>';
                        },
                        item: function (data, escape) 
                        {
                            // Turn off the X close button if it's a bounty or a closeable message type that's been resolved
                            var type = dn.constants.DiscussionTypes[data.TypeId];
                            var noRemoveClass = (type && type.IsCloseable) ? " selectize-no-remove" : "";

                            var status = (typeof $form.data('message-status') !== "undefined" ? $form.data('message-status') : msg.Status);

                            if (($form.data("bounty") && $form.data("bounty").IsOpen) || (msg.Bounty && msg.Bounty.IsOpen))
                            {
                                return '<div class="dn-type dn-type-' + type.TypeKey + ' dn-message-status-' + dn.message.StatusReverse[status] + noRemoveClass + ' dn-bounty-open"><span class="type-name">' + escape(data.Name) + '</span> <span class="dn-bounty-badge">' + dn.constants.TokenCurrencySymbolHtml + dn.DecimalToString($form.data("bounty").Amount, 2) + '</span></div>';
                            }
                            else
                            {
                                return '<div class="dn-type dn-type-' + type.TypeKey + ' dn-message-status-' + dn.message.StatusReverse[status] + '"><span class="type-name">' + escape(data.Name) + '</span></div>';
                            }
                        }
                    }
                })[0].selectize;

                var topics = [];

                // See if they have already selected a topic. If they have, AND already
                // set a message title or body or have not filtered down the message
                // stream to a specific topic, use the one they've already chosen.
                if (msg.Topics && msg.Topics.length > 0 && (msg.Title || (msg.Body && msg.Body !== '<p>&nbsp;</p>') || dn.CurrentTopicId < 1))
                {
                    // they have saved values for the topics
                    topics = msg.Topics;
                }
                else if (dn.CurrentTopicId > 0)
                {
                    // they don't have any saved value, or they do but it doesn't appear that they
                    // really started their message composition, and they are filtered down to a specific topic
                    topics = [dn.CurrentTopicId];
                }

                // AUTOSUGGESTIONS for Topics/Groups
                compose.Selectize[id + '-Topics'] = $form.find('#dn-compose-Topics' + parentKey).selectize({
                    loadThrottle: dn.constants.WaitForAutosuggest,
                    valueField: "TopicId",
                    searchField: "Name",
                    optgroupField: "Type",
                    lockOptgroupOrder: true,
                    optgroups: compose.TopicOptionGroups,
                    // These next two lines pre-fill any existing topics, filtering out any that are groups that
                    // this user is not a subscriber of (since they can't post to them anyway).
                    options: compose.GetTopics($form, msg),
                    items: topics,
                    sortField: [
                        {
                            field: 'SortOrder',
                            direction: 'asc'
                        },
                        {
                            field: 'Name',
                            direction: 'asc'
                        },
                        {
                            field: '$score'
                        }
                    ],
                    persist: true,
                    hideSelected: true,
                    selectOnTab: true,
                    onDropdownOpen: function($dropdown)
                    {
                        // Don't automatically highlight the first item when we open
                        var self = this;
                        setTimeout(function()
                        {
                            if (self.$activeOption)
                            {
                                self.$activeOption.removeClass('active');
                                self.$activeOption = null;
                            }
                        }, 0);
                    },
                    create: false,
                    plugins: ['remove_button', 'restore_on_backspace'],
                    mode: 'multi',
                    highlight: false,
                    maxItems: null,     // we want to allow 2 topics and 10 groups, so we'll handle it in onItemAdd
                    openOnFocus: true,
                    closeAfterSelect: true,
                    preload: false,
                    load: function (query, callback) 
                    {
                        console.debug("Selectize[Topics].load", query);

                        if (!query) 
                        { 
                            callback(); 
                        }
                        else
                        {
                            dn.topic.Query({query: query, onSuccess: function (data) {
                                callback(data);
                            }, onError: function (error) {
                                callback();
                            }});
                        }
                    },
                    onItemAdd: function (topicId, element) 
                    {
                        // add the topic/group
                        compose.ValidateTopics($form);

                        setTimeout
                        (
                            // Wait until we've left this callback before saving, otherwise we may 
                            // not actually "see" the value saved yet.
                            function()
                            {
                                compose.Save($form, false);
                            },
                            10
                        );

                        $(element).find('.topic-name[data-toggle="popover"]').popover();

                        if (dn.constants.TopicWarnings[topicId])
                        {
                            dn.ShowModal
                            ({
                                title: "Please Note",
                                body: dn.constants.TopicWarnings[topicId],
                                closeButtonText: 'OK',
                                closeButtonClass: 'btn-primary'
                            });
                        }
                    },
                    onItemRemove: function (topicId) 
                    {
                        // add the topic/group
                        compose.ValidateTopics($form);

                        setTimeout
                        (
                            // Wait until we've left this callback before saving, otherwise we may 
                            // not actually "see" the value saved yet.
                            function()
                            {
                                compose.Save($form, false);
                            },
                            10
                        );

                        $('[data-value="' + topicId + '"] span.topic-name').popover('dispose');
                    },
                    render: 
                    {
                        optgroup_header: function(data, escape) 
                        {
							return '<div class="topic-optgroup-header">' + escape(data.label) + '</div>';
						},
                        option: function (data, escape) 
                        {
                            return '<div class="dn-metadata-choice topic-type-' + data.Type + '"><span class="topic-name">' + escape(data.Name) + '</span></div>';
                        },
                        item: function (data, escape) 
                        {
                            if (data.ShouldRemove)
                            {
                                return '<div class="dn-topic dn-should-remove" style="background-color: ' + data.ColorPrimary + '; color: ' + data.ColorText + '"><i class="' + dn.topic.GetIconClass(data.Type) + '" title="' + dn.constants.TopicTypeNames[data.Type] + '"></i> <span class="topic-name" data-toggle="popover" title="" data-trigger="hover" data-placement="bottom" data-html="true" data-content="' + (data.RemovalReason != null ? escape('<span class="text-danger">' + data.RemovalReason + '</span>') + '"' : escape(data.Description) ) + '">' + escape(data.NameShort) + '</span></div>';
                            }
                            else
                            {
                                return '<div class="dn-topic" style="background-color: ' + data.ColorPrimary + '; color: ' + data.ColorText + '"><i class="' + dn.topic.GetIconClass(data.Type) + '" title="' + dn.constants.TopicTypeNames[data.Type] + '"></i> <span class="topic-name" ' + ( (data.Description != null && data.Description != 'null') ? 'data-toggle="popover" title="" data-trigger="hover" data-placement="bottom" data-content="' + escape(data.Description) : '') + '">' + escape(data.NameShort) + '</span></div>';
                            }
                        }
                    }
                })[0].selectize;

                // Refresh the options
                dn.compose.Selectize["dn-compose-Topics"].refreshOptions(false);

                // Add a special click/focus handler for our topics box, allowing it to toggle open/closed
                $form.find('div.selectize-control.dn-compose-Topics').on("click", function(e) {
                    dn.compose.ToggleTopicsDropdown(e, true);
                });
                $form.find('input#dn-compose-Topics-selectized').focus(function(e) {
                    dn.compose.ToggleTopicsDropdown(e, false);
                });
            }

            // Updating body and metadata fields based on this type. This also sets up CKEditor
            compose.UpdateBodyAndMetadata($form, msg, typeManagerStatusEditor, isInitialSetup);

            // Set focus, except for edits
            if (!isCompleted) 
            {
                $appendTo.on
                (
                    'shown.bs.collapse', 
                    function () 
                    {
                        console.debug("compose.GetForm", "Set Focus", "shown.bs.collapse", $appendTo);
                        compose.Focus($form, msg);
                    }
                );
            }

            try 
            {
                compose.SetupForm($form, msg, id, parentKey, $appendTo, $button);
            }
            catch (error) 
            {
                console.error("compose.GetForm", error);
            }
        }

        return $form;
    };

    /**
     * Return all the topics that can appear in the Topics selectize box, which can change
     * depending on what it's in the Type field.
     * 
     * @param ($element)    $form   - The $form we're changing. Also how we determine the currently chosen Type.
     */
    compose.GetTopics = function($form, msg)
    {
        // Get the allowed topics for the current message type, or null if no type or it doesn't have AllowedTopics
        var typeId = $form.data("type-id");
        var allowedTopics = typeId && dn.constants.DiscussionTypes[typeId].AllowedTopics.length !== 0
            ? dn.constants.DiscussionTypes[typeId].AllowedTopics
            : [];
        var requiredTopics = typeId && dn.constants.DiscussionTypes[typeId].RequiredTopics.length !== 0
            ? dn.constants.DiscussionTypes[typeId].RequiredTopics
            : [];

        // Filter topics down to just those that are enabled, topics/non-private groups,
        // and there are no "allowedTopics" filters to worry about.
        var topics = Object.keys(dn.constants.Topics).map
        (
            function(key)
            {
                return dn.constants.Topics[key]
            }
        );

        if (allowedTopics.length > 0 || requiredTopics.length > 0)
        {
            // This flow will require that any topics be found in the current type's `AllowedTopics`
            // or `RequiredTopics` fields.
            topics = topics.filter
            (
                function(topic) 
                {
                    return (
                        topic.IsEnabled // The topic is enabled

                        && 

                        (
                            // Is a topic or not a private group or we have a subscription to it.
                            topic.IsTopic ||
                            !topic.IsPrivateGroup || 
                            dn.user.TopicSubscriptions.indexOf(topic.TopicId) > -1
                        )

                        &&

                        // this topic is allowed by the type OR the topic was one the user had selected already and we don't want to remove it
                        (
                            // this is an allowed topic
                            allowedTopics.indexOf(topic.TopicId) > -1 
                            || 
                            // or this is a required topic
                            requiredTopics.indexOf(topic.TopicId) > -1 
                            || 
                            // or the topic was previously chosen by the user
                            (
                                compose.Selectize["dn-compose-Topics"] 
                                // try to pull from the existing form, in case it's edited...
                                ? compose.Selectize["dn-compose-Topics"].items 
                                // ...but if it doesn't exist, try to get topics out of the msg passed in
                                : ((msg || {}).Topics || [])
                            )
                            .indexOf(topic.TopicId) > -1
                        )
                    );
                }
            );

            if (requiredTopics && requiredTopics.length === 1)
            {
                // There's a single required topic for this type, so select it.
                setTimeout
                (
                    function()
                    {
                        if (dn.compose.Selectize["dn-compose-Topics"].items.length === 0)
                        {
                            console.debug("SetTopic", "RequiredTopic", requiredTopics[0]);
                            compose.Selectize["dn-compose-Topics"].clear(true);
                            compose.Selectize["dn-compose-Topics"].addItem(requiredTopics[0]);
                        }
                    },
                    10
                );
            }
            else if (topics.length === 1)
            {
                // We're filtering by type and there's only one matching topic, so choose it.
                setTimeout
                (
                    function()
                    {
                        if (dn.compose.Selectize["dn-compose-Topics"].items.length === 0)
                        {
                            console.debug("SetTopic", "AllowedTopic", topics[0]);
                            compose.Selectize["dn-compose-Topics"].clear(true);
                            compose.Selectize["dn-compose-Topics"].addItem(topics[0].TopicId);
                        }
                    },
                    10
                );
            }
        }
        else
        {
            // This version doesn't try to filter based on type (because there is 
            // no type yet, or it does not limit where it's type can be posted).
            topics = topics.filter
            (
                function(topic) 
                {
                    return (
                        topic.IsEnabled // The topic is enabled
                        && 
                        (
                            // Is a topic or not a private group or we have a subscription to it.
                            topic.IsTopic ||
                            !topic.IsPrivateGroup || 
                            dn.user.TopicSubscriptions.indexOf(topic.TopicId) > -1
                        )
                    );
                }
            );
        }

        return topics;
    };

    /**
     * When an editor receives focus, we handle that here. For now, we're just tracking the 
     * last editor that was focused, e.g. for file drag&drop.
     */
    compose.HandleEditorFocus = function(event)
    {
        var id = $(this).attr("id");
        // Save the latest focused editor as LastEditor
        compose.LastEditor = compose.Editors[id];
    };

    /**
     * Process errors from our API. We call this on `.fail()` for both posting new messages
     * as well as starting new private message conversations.
     */
    compose.HandleErrors = function($form, xhr, textStatus, errorThrown)
    {
        console.debug("compose.HandleErrors", $form, xhr, textStatus, errorThrown);

        if (dn.IsErrorHandledAutomatically(null, xhr, null, errorThrown)) 
        {
            return;
        }

        var errorCount = 0;
        var parentKey = $form.data("parentkey");

        $.each(compose.FieldsForErrors, function (index, value) 
        {
            var errors = "";
            var selector = 'dn-compose-' + value + parentKey;

            if (xhr && xhr['responseJSON'] && xhr.responseJSON[value]) 
            {
                // this field threw error(s) that we need to show
                if ($.isArray(xhr.responseJSON[value])) 
                {
                    // it threw multiple errors
                    $.each(xhr.responseJSON[value], function (index2, value2) 
                    {
                        errors += value2 + " ";
                        errorCount++;
                    });
                }
                else 
                {
                    errors = xhr.responseJSON[value];
                    errorCount++;
                }

                $form.find("#" + selector + ", .input-group." + selector).addClass("is-invalid");
                var $errorField = $form.find("#" + selector + '-error');
                $errorField.text(errors);

                // See if we can find an input-prepend for our selectize-related errors
                var prependWidth = $("div.input-group." + selector + " div.input-group-prepend").width();
                if (!prependWidth)
                {
                    // That didn't find anything, maybe it's a plain old input field with a prepend, like Title.
                    prependWidth = $("input.form-control." + selector).siblings("div.input-group-prepend").width();
                }

                if (prependWidth > 0)
                {
                    // Let's slide the error message to the right a bit to line up with the input field
                    console.debug("compose.Save", "Error Slide", selector, prependWidth);
                    $errorField.css("padding-left", prependWidth + "px");
                }

                $errorField.show();
            }
            else 
            {
                // no error was thrown, clear any previous errors
                $form.find("#" + selector + ", .input-group." + selector).removeClass("is-invalid");
                $form.find("#" + selector + '-error').text("").hide();
            }
        });

        if (xhr && xhr['responseJSON'] && xhr.responseJSON[""]) // generic for generic model errors
        {
            var errors = "";

            if ($.isArray(xhr.responseJSON[""])) 
            {
                // it threw multiple errors
                $.each(xhr.responseJSON[""], function (index2, value2) 
                {
                    errors += value2 + " ";
                    errorCount++;
                });
            }
            else 
            {
                errors = xhr.responseJSON[""];
                errorCount++;
            }

            $form.find(".dn-compose-error-message").html(errors);
            $form.find(".dn-compose-error").show();
        }
        else 
        {
            // no generic errors
            $form.find(".dn-compose-error-message").html("");
            $form.find(".dn-compose-error").hide();
        }

        if (errorCount == 0) 
        {
            // No recognized error, so give a generic message
            $form.find(".dn-compose-error-message").html(dn.FormatApiError(xhr.responseJSON)).show();
            $form.find(".dn-compose-error").show();
        }
    };

    /**
     * We bind these event to drag/drop events in the CKEditor body fields, allowing us to handle inserting links to the files.
     */
    compose.HandleFileDrop = function (event, data) 
    {
        // Get the editor they dropped this file into.
        var editor = compose.Editors[$(data.domTarget).attr("id")];

        if (compose.DragEvent && compose.DragEvent.target && $(compose.DragEvent.target).parents('.dn-file-wrapper').length > 0) 
        {
            var url = dn.constants.BaseHref + "/file/" + $(compose.DragEvent.target).parents('.dn-file-wrapper').attr('id');
            editor.model.change(function (writer) 
            {
                var insertPosition = editor.model.document.selection.getLastPosition();
                // var insertPosition = data.dropRange.start;  // ERROR: https://ckeditor.com/docs/ckeditor5/latest/framework/guides/support/error-codes.html#error-model-selection-setTo-not-selectable
                var linkedText = writer.createText(url, { linkHref: url });
                editor.model.insertContent(linkedText, insertPosition);
            });
        }
    };

    /**
     * This attaches uploaded files to the current message. 
     * 
     * @param {object} response     - The response from the Filestack API after files are uploaded. 
     * @param {element} fileKeys    - The collection of current file keys
     * @param {element} fileTypes   - The collection of current file types 
     * @param {element} onComplete  - The function to call when we are finished
     * 
     * Note: This function is also used in chat PM's for handling files 
     */
    compose.HandleFiles = function(response, fileKeys, fileTypes, onComplete) 
    {
        // insert our needed properties, FileId and FileKey
        $.each(response.filesUploaded, function(index, value) 
        {
            if (!value['FileId'])
            {
                value['FileId'] = 0;
                value['FileKey'] = null;
            }
        });

        // Post to our file API to record these newly uploaded files
        $.postJSON("/api/v1/file", response.filesUploaded).done(function(files) 
        {
            // extract FileKeys from the response into a single array
            var newFileKeys = files.map(function(file) {return file.FileKey;});

            // append the new filekeys to the existing set of files attached to this message, if any
            fileKeys.push.apply(fileKeys, newFileKeys);

            // extract FileTypes from the response into a single array
            var newFileTypes = files.map(function(file) {return file.Type;});

            // append the new fileTypes to the existing set of files attached to this message, if any
            fileTypes.push.apply(fileTypes, newFileTypes);

            if (onComplete)
            {
                onComplete()
            }
        })
        .fail(function(xhr, textStatus, errorThrown) 
        {
            if (!dn.IsErrorHandledAutomatically(null, xhr, null, errorThrown)) 
            {
                // The initial request for the message details failed, tell the user
                var body = dn.FormatApiError(xhr.responseJSON);
                dn.ShowModal({title: "Upload Error", body: body});
            }
        });
    };

    /**
     * Initialize our file uploader. This will only do work one time, after
     * that it knows it's already setup and will not do anything further.
     */
    compose.InitFileUploader = function(onComplete, onFail) 
    {
        if (!fileUploaderInitialized)
        {
            $.getScript(dn.constants.UrlFilestackJs)
            .done(function(script, textStatus) 
            {
                fileUploaderInitialized = true;
                compose.FileUploader = filestack.init(dn.constants.ApiKeyFileUploads);

                if (onComplete)
                {
                    onComplete(script, textStatus);
                }
            })
            .fail(function(jqxhr, settings, exception) 
            {
                // TODO: Disable the upload button, or figure out a good retry scenario
                console.error("compose.InitFileUploader", "Filestack file uploader could not be downloaded!", jqxhr, exception);

                if (onFail)
                {
                    onFail(jqxhr, settings, exception);
                }
            });
        }
        else if (onComplete)
        {
            onComplete();
        }
    };

    /**
     * Fill in the given message body into the given form. 
     * 
     * If the current form has a multipart body, but there's nothing in `msg.BodyParts`, then 
     * see if `msg.Body` is set, and if so, use that. And vice versa, if it's a single part,
     * but `msg.Body` is not set and `msg.BodyParts` is, then try to convert those to fit.
     * 
     * @param {element} $form - The form element representing the compose form.
     * @param {object}  msg   - The Message to use to fill in the body.
     */
    compose.FillFormBody = function ($form, msg) 
    {
        var keyPrefix = $form.attr('id') + '-Body';
        var bodyPartKeys = Object.keys(msg.BodyParts || {});

        var lastMultipartTypeId = $form.data("last-multipart-type-id");
        var lastMultipartType = lastMultipartTypeId ? dn.constants.DiscussionTypes[lastMultipartTypeId] : null;

        if ($form.data("is-multipart"))
        {
            if (bodyPartKeys.length > 0)
            {
                // It's a multipart post and they have multipart data, use it, by looping
                // through each body PartKey, and if that editor field exists, set the value.
                bodyPartKeys.forEach
                (
                    function(partKey)
                    {
                        var fullKey = keyPrefix + '-' + partKey;
                        if (compose.Editors[fullKey])
                        {
                            if (dn.constants.UseRichTextEditor)
                            {
                                compose.Editors[fullKey].setData(msg.BodyParts[partKey]);
                            }
                            else
                            {
                                compose.Editors[fullKey].val(msg.BodyParts[partKey]);
                            }
                        }
                    }
                );
            }
            else if (msg.Body)
            {
                // It's a multipart post, but they only have a single part body, so we're 
                // just going to put it in the first body part field.
                var fullKey = $form.find(".dn-compose-Body-multipart").first().attr("id");
                if (fullKey)
                {
                    // We did find the first multipart field, so we can put it in there.
                    if (dn.constants.UseRichTextEditor)
                    {
                        compose.Editors[fullKey].setData(msg.Body);
                    }
                    else
                    {
                        compose.Editors[fullKey].val(msg.Body);
                    }
                }
            }

            // TODO: If we ever support more than one type that has multipart bodies, we'll
            // need to figure out how to transition between two different multiparts, while
            // trying to retain the user's previously typed text.
        }
        else
        {
            // Not multipart, but a single body
            if (msg.Body)
            {
                // Great, they have a single body that we can use
                if (dn.constants.UseRichTextEditor) 
                {
                    compose.Editors[keyPrefix].setData(msg.Body);
                } 
                else 
                {
                    compose.Editors[keyPrefix].val(msg.Body);
                }
            }
            else if (bodyPartKeys.length > 0)
            {
                // Uh-oh, no single body. We'll try to create one we can use by looping
                // through their multipart bodyparts, and treating them as paragraphs. 
                var fullKey = $form.find(".dn-compose-Body").first().attr("id");
                if (fullKey)
                {
                    var body = [];

                    if (lastMultipartType && lastMultipartType.Template && lastMultipartType.Template.BodyParts)
                    {
                        lastMultipartType.Template.BodyParts.forEach
                        (
                            function(bodyPart, idx)
                            {
                                if (msg.BodyParts[bodyPart.PartKey])
                                {
                                    body.push(msg.BodyParts[bodyPart.PartKey]);
                                }
                            }
                        )
                    }
                    else
                    {
                        // No clue what order they should go in since we can't find the type
                        // that they previously had selected that was multipart, so just add
                        // the body parts in any order.
                        bodyPartKeys.forEach
                        (
                            function(partKey)
                            {
                                body.push(msg.BodyParts[partKey]);
                            }
                        );
                    }

                    // Now add the constructed body array to the editor field
                    if (dn.constants.UseRichTextEditor)
                    {
                        compose.Editors[fullKey].setData(body.join("\n\n"));
                    }
                    else
                    {
                        compose.Editors[fullKey].val(body.join("\n\n"));
                    }
                }
            }
        }
    };

    /**
     * Checks the provided topic id's against the list user has/owns
     * 
     * @param {int[]} topicIds the list of topic ID's to check against
     * @param {function(string)} onSuccess the success function to call when completed, also returns the list
     * @param {function} onFailure the function to call when a failure is encountered
     */
    compose.GetMissingBadgeIdsForTopics = function(topicIds, onSuccess, onFailure)
    {
        if (!topicIds || topicIds.length === 0 || !dn.user.IsLoggedIn)
        {
            onSuccess([]);
        }

        var missingRequiredBadges = [];
        var numberOfTopicsChecked = 0;
        var closedOrPrivate = false;

        $.each
        (            
            topicIds,
            function(index) 
            {
                dn.topic.Lookup
                ({
                    topicIdOrKey: topicIds[index], 
                    showAjaxSpinner: true, 
                    onSuccess: function(topic) 
                    {
                        if (!closedOrPrivate || !topic.IsTopic)
                        {
                            if (topic.IsPrivateGroup || topic.IsClosedGroup)
                            {
                                // In general this should work because we place the
                                // closed or private group first in the list of topics.
                                // And then for any additional topics, we'll just ignore
                                // the topic badge requirements if closedOrPrivate is true.
                                closedOrPrivate = true;
                            }
                            
                            // Add the unique missing badge ids from the required badges (only if we haven't already added them)
                            missingRequiredBadges = missingRequiredBadges.concat
                            (
                                topic.RequiredBadges.filter
                                (
                                    function(badgeId) 
                                    { 
                                        return !dn.user.BadgeIds.has(badgeId) && !missingRequiredBadges.includes(badgeId);
                                    }
                                )
                            );
                        }

                        numberOfTopicsChecked++;

                        if (numberOfTopicsChecked === topicIds.length)
                        {
                            onSuccess(missingRequiredBadges);
                        }
                    },
                    onFailure: function(topic)
                    {
                        console.debug("Could not load topic " + topic);
                        numberOfTopicsChecked++;

                        if (numberOfTopicsChecked === topicIds.length)
                        {
                            onFailure();
                        }
                    }
                });
            }                        
        );
    }

    /**
     * Checks the provided topic id's against the list user has/owns
     * 
     * @param {int[]} badgeIds the list of badge id's to generate html for
     */
    compose.GenerateBadgesHTML = function(badgeIds) 
    {
        var badgeHTML = "";

        if (badgeIds.length != 0)
        {
            for (var i = 0; i < badgeIds.length; i++)
            {
                var currentBadge = dn.constants.Badges[badgeIds[i]];
                badgeHTML += 
                    '<a href="' + currentBadge.Link + '" class="dn-badge" style="' + currentBadge.Styles + '">' + 
                        currentBadge.Name + 
                    '</a>';
            }                                                               
        }           

        return badgeHTML;
    };

    /**
     * This is called from within HandlePostButtonClick after the initial badge checks are done.
     * 
     * @param {event} event The original event that triggered this posting form toggle.
     * @param {int} typeId the message type id, if any
     * @param {string} parentKey the message being replied to, if this is a reply
     */
    function togglePostingForm(event, typeId, parentKey)
    {
        if ($(event.currentTarget).data('dn-current-status') !== 'open' && dn.user.IsLoggedIn && !dn.IsDiscussionAnonymized && dn.CurrentTopicId > 0)
        {
            // They are hitting the Post button from a topic- or group-
            // specific page, but they aren't subscribed to this topic/group,
            // so check to see if it's a non-disabled topic or open group, or group
            // that they are subscribing to. If it is, let proceed normally. Otherwise, 
            // show an error explaining what's up.
            dn.topic.Lookup
            (
                {
                    topicIdOrKey: dn.CurrentTopicId, 
                    showAjaxSpinner: false, 
                    onSuccess: function(topic) 
                    {
                        if (!topic.IsEnabled)
                        {
                            dn.ShowModal
                            (
                                {
                                    title: (topic.IsGroup ? "Group" : "Topic") + " is Disabled",
                                    body: "This " + (topic.IsGroup ? "group" : "topic") + " is disabled, which means no new messages can be posted to it."
                                }
                            );
                            return false;
                        }
                        else if (dn.user.TopicSubscriptions.indexOf(dn.CurrentTopicId) === -1 && (topic.IsClosedGroup || topic.IsPrivateGroup))
                        {
                            // This is a closed or private group that they aren't subscribed to, which means we need to show an error.
                            dn.PromptToSubscribe(topic.TopicId, (parentKey ? "reply to a message in it" : "post a new message to it"), function(e) 
                            {
                                // they did subscribe, so go ahead and open the posting form
                                if (dn.user.IsLoggedIn && parentKey && typeId == dn.constants.BountyTypeId)
                                {
                                    // This is a reply to a bounty, from a logged-in user, so make sure they've agreed to our agreement.
                                    dn.agreement.Verify
                                    (
                                        'Bounties', 
                                        function() 
                                        {
                                            dn.compose.Toggle(event);
                                        }
                                    );
                                }
                                else
                                {
                                    dn.compose.Toggle(event);
                                }
                            });

                            return false;
                        }

                        if (dn.user.IsLoggedIn && parentKey && typeId == dn.constants.BountyTypeId)
                        {
                            // This is a reply to a bounty, from a logged-in user, so make sure they've agreed to our agreement.
                            dn.agreement.Verify
                            (
                                'Bounties', 
                                function() 
                                {
                                    dn.compose.Toggle(event);
                                }
                            );
                        }
                        else
                        {
                            // This is a topic, not a group, and not a bounty reply, so just let them continue to post to it.
                            dn.compose.Toggle(event);
                        }
                    }, 
                    onError: function() 
                    {
                        // we're not sure if they can post to this group, so just let this continue.
                        dn.compose.Toggle(event);
                    }
                }
            );
        }
        else if (dn.user.IsLoggedIn && parentKey && typeId == dn.constants.BountyTypeId)
        {
            // This is a reply to a bounty, from a logged-in user, so make sure they've agreed to our agreement.
            dn.agreement.Verify
            (
                'Bounties', 
                function() 
                {
                    dn.compose.Toggle(event);
                }
            );
        }
        else
        {
            dn.compose.Toggle(event);
        }
    }

    /**
     * Called when someone clicks the Post button, either at the top of the homepage stream,
     * or as a reply to a discussion. It then toggles open the compose form. 
     */
    compose.HandlePostButtonClick = function(event) 
    {
        var parentKey = $(this).data('dn-parentkey');
        var typeId = parseInt($(this).data('type-id'));

        if (!dn.user.IsLoggedIn)
        {
            // Anon users get asked to login first
            dn.PromptToLogin(parentKey != "" ? 'reply to messages' : 'post messages');
            return;
        }

        // This is not a new message, it is a reply 
        // so we must check that we are able reply to it
        if (parentKey != "")
        {
            dn.compose.GetMissingBadgeIdsForTopics
            (
                getCurrentTopicIds(), 
                function(missingBadgeIds)
                {
                    if (missingBadgeIds.length > 0)
                    {
                        compose.ShowMissingBadgeModalForTopicAction(missingBadgeIds, "reply to messages");
                    }
                    else
                    {
                        togglePostingForm(event, typeId, parentKey);
                    }
                },
                function()
                {
                    dn.ShowModal("Error", "Unknown error.")
                }
            );
        }
        else
        {
            togglePostingForm(event, typeId, parentKey);
        }
    };

    /**
     * Called when any page is loading that needs to initiate composition functions. 
     * I.e. typically this would be called from the homepage and the discussion page.
     */
    compose.Init = function()
    {
        console.debug("compose.Init");

        // Preload in the background so that there's no delay if they choose to compose
        dn.LoadRichTextEditor(); 

        compose.AddEventHandlers();
    };

    /**
     * Check the form for .dn-compose-edit to detect if this is message edit form (vs. a message create)
     */
    compose.IsEdit = function($form) 
    {
        return $form && ($form.hasClass("dn-compose-edit") || $form.find(".dn-compose-edit").length > 0);
    };

    /**
     * 
     * @param {element} $form - Our composition form
     * @param {string} fileKey - The identifier of the file to be removed.
     * @param {function} onRemoved - A callback function to execute after we've removed files and saved our changes.
     */
    compose.RemoveFile = function($form, fileKey, onRemoved) 
    {
        var key = 'files' + $form.data('parentkey');

        $('#' + fileKey).remove();

        if (compose.FileKeys[key] && compose.FileKeys[key].length > 0)
        {
            // Loop backwards so we can remove any matching files from the array without adjusting anything
            var i = compose.FileKeys[key].length;
            while (i--) {
                if (compose.FileKeys[key][i] == fileKey) { 
                    compose.FileKeys[key].splice(i, 1);
                    compose.FileTypes[key].splice(i, 1);
                }
            }

            if (compose.FileKeys[key].length == 0)
            {
                $form.find(".dn-attachments").removeClass("has-attachments");
            }

            // Now save our changes to this message
            // TODO: Actually remove the file from our database and Filestack!
            compose.Save($form, false, onRemoved);
        }
    };

    /**
     * Clear any errors currently shown for this form.
     * 
     * @param {element} $form - The form containing the errors we want to clear.
     */
    compose.ResetErrors = function($form)
    {
        var parentKey = $form.data("parentkey");
        // clear any errors that were previously shown
        $.each(compose.FieldsForErrors, function( index, value ) {
            var selector = 'dn-compose-' + value + parentKey;
            $form.find("#" + selector + ", .input-group." + selector).removeClass("is-invalid");
            $form.find("#" + selector + '-error').text("").hide();
        });
        $form.find(".dn-compose-error-message").html("");
        $form.find(".dn-compose-error").hide();
    };

    /**
     * This function will save the changes to the user's post, possibly finalizing/posting it for all to see.
     * It is usually called automatically as the user types, or if they press the "Save" button to 
     * close down the posting form.
     * 
     * @param {element} $form - The form element representing the compose form.
     * @param {boolean} isCompleted - Whether or not this finalizes the message and it should be considered posted.
     * @param {func} onSaved - Callback we call after the message is saved.
     */
    compose.Save = function($form, isCompleted, onSaved)
    {
        var isEdit = compose.IsEdit($form);

        // They must have edited something, so show the editor notes / status form if it's not visible yet
        if (!isCompleted && $(".dn-compose-edit-box.dn-editor-notes:visible").length === 0)
        {
            console.debug("compose.Save", "Showing editor notes / message status box.");
            $(".dn-compose-edit-box.dn-editor-notes").show();

            // Listen to changes in the editor notes field also
            compose.SetupTextFields($(".dn-compose-EditorNotes"), $form);
        }

        // Don't autosave if this is an edit (unless they hit the "finish" button, which will set isCompleted=true)
        if (isEdit && !isCompleted) 
        {
            if (onSaved) 
            {
                onSaved();
            }
            return;
        }

        // show that we're auto-saving
        var $saving = $form.find(".dn-compose-saving");
        $saving.find(".dn-saving-large").text(isCompleted ? "Finishing" : "Saving"); // text shown on larger devices
        $saving.show();

        var messageKey = $form.data("messagekey");
        var parentKey = $form.data("parentkey");
        var typeId = $form.data("type-id");
        var formId = $form.attr('id');

        var type = dn.constants.DiscussionTypes[typeId];
        var filesKey = 'files' + parentKey;

        console.debug
        (
            "compose.Save", 
            {
                $form: $form, 
                parentKey: parentKey, 
                messageKey: messageKey, 
                isEdit: isEdit, 
                isCompleted: isCompleted
            }
        );

        // New discussions and replies get this data
        var data = 
        {
            ParentKey: parentKey,
            Body: null,
            BodyParts: {},
            Completed: isCompleted,
            EditorNotes: ($('#dn-compose-EditorNotes' + parentKey).val() || null),
            EditNotify: ($('#dn-compose-EditorNotesNotify' + parentKey).prop('checked') || false),
            FileKeys: (compose.FileKeys[filesKey] || []),
            FileTypes: (compose.FileTypes[filesKey] || []),
            Format: (dn.constants.UseRichTextEditor ? "Html" : "Plain"),
            Metadata: {}, // we'll try to fill this in below
            Status: 
            (
                type 
                ? (
                    $form.find('.dn-compose-message-status').val() || 
                    (typeof $form.data('message-status') !== "undefined" 
                        // use the data-message-status if it's defined
                        ? $form.data('message-status') 
                        // otherwise...
                        : (parentKey 
                            // if this is a reply, default to 0
                            ? 0
                            // or a root message, default to the type's default status, or 0 if that's not defined
                            : (dn.constants.DiscussionTypes[typeId].DefaultStatus || 0)
                        )
                    )
                )
                // No type yet set
                : null
            )
        };

        var bodyKey = formId + "-Body";

        // The fields used in our form. These are used to check for errors when we hear back from the server.
        // We'll add on any body/multipart and metadata fields further below. The values here must correspond
        // to the field names, and will be lowercased when looking at the DOM's `dn-compose-*-error` fields.
        compose.FieldsForErrors = ["Topics", "Type", "Title"];

        if (!data.ParentKey) 
        {
            // Only new discussions get this data
            data.Title = $form.find("#dn-compose-Title").val();

            // set type based on what they've chosen, unless there is a bounty attached, in which case we override
            data.TypeId = $form.find("#dn-compose-Type").val();

            // process the topic(s)
            var idKey = formId + "-Topics";

            if (dn.compose.Selectize[idKey] && $.isArray(dn.compose.Selectize[idKey].items) && dn.compose.Selectize[idKey].items.length > 0) 
            {
                data.Topics = dn.compose.Selectize[idKey].items;
            }
            else 
            {
                data.Topics = [];
            }

            // Process any metadata
            if (type && type.Template.IsBodyMultipart)
            {
                // This is NOT a reply, we have a type, and it's a multi-part body type
                if (dn.constants.UseRichTextEditor)
                {
                    // Iterate through the body parts and get the CKEditor data from the field
                    type.Template.BodyParts.forEach
                    (
                        function(bodyPart)
                        {
                            data.BodyParts[bodyPart.PartKey] = compose.Editors[formId + "-Body-" + bodyPart.PartKey].getData();
                            compose.FieldsForErrors.push("Body-" + bodyPart.PartKey);
                        }
                    );
                }
                else
                {
                    // Iterate through the body parts and get the val() from the textarea
                    type.Template.BodyParts.forEach
                    (
                        function(bodyPart)
                        {
                            data.BodyParts[bodyPart.PartKey] = compose.Editors[formId + "-Body-" + bodyPart.PartKey].val();
                            compose.FieldsForErrors.push("Body-" + bodyPart.PartKey);
                        }
                    );
                }
            }
            else if (compose.Editors[bodyKey])
            {
                // Non-multipart type or no type yet
                data.Body = dn.constants.UseRichTextEditor 
                    ? compose.Editors[bodyKey].getData()
                    : compose.Editors[bodyKey].val();

                compose.FieldsForErrors.push("Body");
            }
        }
        else if (compose.Editors[bodyKey])
        {
            // This is a reply, therefore it's definitely not a multipart body
            data.Body = dn.constants.UseRichTextEditor 
                ? compose.Editors[bodyKey].getData()
                : compose.Editors[bodyKey].val();

            compose.FieldsForErrors.push("Body");
        }

        if (type)
        {
            // Iterate over every metadata field associated with this message type
            type.Template.Fields.forEach
            (
                function(field)
                {
                    // define a unique identifier for this template+metadata key
                    var metadata = dn.constants.Metadata[field.MetadataId];
                    var uniqueId = "dn-compose" + data.ParentKey + "-" + type.Template.TemplateKey + "-" + metadata.MetadataKey;

                    if (!dn.metadata.Selectize[uniqueId] || data.ParentKey && (!field.AllowedOnReplies || dn.metadata.Selectize[uniqueId].items.length === 0))
                    {
                        // This is a reply, and this field is not allowed for replies
                        return;
                    }

                    compose.FieldsForErrors.push(type.Template.TemplateKey + "-" + metadata.MetadataKey);

                    if (metadata.Type === dn.constants.MetadataType.Autosuggest)
                    {
                        data.Metadata[metadata.MetadataKey] = dn.metadata.Selectize[uniqueId].items.map
                        (
                            function(key) 
                            {
                                if (dn.metadata.Selectize[uniqueId].options[key]["$order"])
                                {
                                    delete dn.metadata.Selectize[uniqueId].options[key]["$order"];
                                }
                                return dn.metadata.Selectize[uniqueId].options[key];
                            }
                        );
                    }
                }
            );

            console.debug("compose.Save", "Metadata", data.Metadata);
        }

        // Post the message updates to our API
        $.putJSON
        (
            "/api/v1/message/" + messageKey, 
            data
        )
        .done
        (
            function (response) 
            {
                compose.Messages[response.Message.MessageKey] = response.Message;
                compose.FileKeys[filesKey] = response.Message.FileKeys;
                compose.FileTypes[filesKey] = response.Message.FileTypes;

                dn.message.UpdateRootStatus(response.RootStatus || (response.TypeId ? dn.constants.DiscussionTypes[response.TypeId].DefaultStatus : dn.message.Status.Default));

                $form.find(".dn-compose-saving").hide();

                if (isCompleted) 
                {
                    $form.find("input, textarea, select").off('keydown paste cut input').val(""); // stop watching input and clear the form

                    // Remove this entry from our FilledForms object which tracks filled forms,
                    // so that if they decide to edit a newly posted reply, the form gets rebuilt correctly.
                    delete compose.FilledForms[response.Message.MessageKey];
                }

                if (onSaved) 
                {
                    onSaved(response);
                }
            }
        )
        .fail
        (
            function (xhr, textStatus, errorThrown) 
            {
                $form.find("button.dn-compose-post").prop('disabled', false); // enable the post button
                $form.find(".dn-compose-saving").hide();

                dn.compose.HandleErrors($form, xhr, textStatus, errorThrown);

                // scroll to top so they can see the errors
                $('html, body').animate
                (
                    {
                        scrollTop: $form.offset().top
                    }, 
                    750
                );
            }
        );
    };

    /**
     * Show the "Set Initial Status" popup.
     * 
     * @param {element} $form  - The element that represents the compose form.
     * @param {bool}    type   - The DiscussionType object that is currently set.
     */
    compose.SetInitialStatus = function($form, type, onClose) 
    {
        var title = 'Choose Initial Status';
        var formId = $form.attr('id');
        var parentKey = $form.data("parentkey");

        // Sometimes we may end up here with the Types box still open (like when calling compose.StartPost()),
        // so here we're going to make sure the dropdown has been closed up.
        if (compose.Selectize['dn-compose-Type'])
        {
            compose.Selectize['dn-compose-Type'].close();
        }

        var messageStatusOptions = '';

        type.InitialStatuses.forEach
        (
            function (status)
            {
                // messageStatusOptions += '<option value="' + status + '">' + dn.message.StatusNouns[status] + '</option>';
                messageStatusOptions += '<div class="row mb-2"><div class="col-4 pt-1"><button type="button" class="btn btn-block dn-message-status dn-message-status-' + dn.message.StatusReverse[status] + '" data-initial-status="' + status + '">' + dn.message.StatusVerbs[status] + '</button></div><div class="col text-small">' + dn.message.StatusExplanationInitial[status].replaceAll('{0}', type.Name) + '</div></div>';
            }
        );

        $('#' + compose.SetStatusId).remove();  // remove if it already exists
        $("body").append($('<div class="modal" tabindex="-1" role="dialog" style="display: none" id="' + compose.SetStatusId + '">\
            <div class="modal-dialog" role="document">\
                <div class="modal-content">\
                    <div class="modal-header">\
                        <h5 class="modal-title"><b>' + title + '</b></h5>\
                        <button type="button" class="close ' + compose.SetStatusId + '-close" data-dismiss="modal" aria-label="Close">\
                        <span aria-hidden="true">&times;</span>\
                        </button>\
                    </div>\
                    <div class="modal-body pb-0">\
                        <p>' + type.Description + '</p><p class="mb-3">Please choose the initial status:</p>\
                        <div class="d-flex-block align-items-center mb-3 ml-0">\
                            <div class="input-group">' +
                                messageStatusOptions + 
                            '</div>\
                        </div>\
                        <p id="closing-modal"></p>\
                    </div>\
                </div>\
            </div>\
        </div>'));

        // stop any spinners and close any open modals before showing our new one
        dn.Spin(false);

        var id = '#' + compose.SetStatusId;
        $(id).modal();

        // Change Initial Status button clicked
        $(id + ' .dn-message-status').on("click", function(event) 
        {
            // Set the initial status and save draft
            $form.data('message-status', $(this).data('initial-status'));

            compose.Selectize[formId + '-Type'].clearCache(type.TypeId); // clear the render cache for this item

            if (!compose.Selectize[formId + '-Type'].getValue()) 
            {
                // If for some reason the Type box is not present, put it in place.
                compose.Selectize[formId + '-Type'].addItem(type.TypeId);
            }

            // now force it to re-render
            compose.Selectize[formId + '-Type'].updateOption(type.TypeId, compose.Selectize[formId + '-Type'].options[type.TypeId]);
            compose.ShowTypeInfo($form, parentKey, type.TypeId);

            $form.find('.dn-type-' + type.TypeKey).off('click').on("click", function(e) 
            {
                if (!$(e.target).hasClass("remove"))
                {
                    compose.SetInitialStatus($form, type); 
                }
            });

            compose.Save($form, false);
            $(id).modal('hide');
        });

        // Close button clicked
        $('.' + compose.SetStatusId + '-close').on("click", function(event) 
        {
            if (onClose)
            {
                onClose();
            }
        });

        $(id).modal('show');
    };

    /**
     * Additional setup for the form.
     * 
     * @param {element} $form                   - The form we want to fill these values into.
     * @param {object}  msg                     - The message that the person was working on, if any.
     */
    compose.SetupForm = function ($form, msg, id, parentKey, $appendTo, button) 
    {

        $form.find("button.dn-compose-post").prop('disabled', false); // make sure it's enabled

        // Hide the error message if it happened to be showing already
        $form.find(".dn-compose-error").hide();

        $form.data("messagekey", msg.MessageKey);   // save for later
        $form.data("parentkey", parentKey);         // save for later
        $form.data("type-id", msg.TypeId);          // save for later

        console.debug("compose.SetupForm", msg);

        // Setup the post button click to FINISH the message: submit the post to the API (Completed: true)
        $form.find("button.dn-compose-post").on("click", function () 
        {
            $form.find("button.dn-compose-post").prop('disabled', true); // disable the post button
            compose.ResetErrors($form);

            compose.Save($form, true, function (response) 
            {
                // After it's saved, collapse the posting form and change the trigger button back to closed state
                button.data('dn-current-status', 'closed');

                if (compose.IsEdit($form)) 
                {
                    $appendTo.addClass('d-none').removeClass('dn-edit-box');
                }
                else
                {
                    $appendTo.collapse('hide');
                }

                // Since we've completed this message/reply, remove the form from the DOM.
                $form.remove();

                button.removeClass("dn-pressed").children('span').text(button.data('dn-button-label-closed'));

                // clear the "edits in progress" list before reloading the page
                compose.MessageEditsInProgress = []; 

                if (!parentKey || Object.keys(response.Message.Metadata).length > 0) 
                {
                    // It's a new message being posted, send them to the new discussion.
                    // Or it's a reply with metadata attached to it, so we need to reload the page to show the metadata
                    // TODO: Eventually we should render the metadata without a page reload.
                    window.location.href = response.Message.Link;
                }
                else 
                {
                    // Insert the reply into the discussion.
                    if (response.RootStatus > 0)
                    {
                        // update the discussion's status
                        dn.message.UpdateRootStatus(response.RootStatus);
                    }

                    insertReply(parentKey, response.Message); 
                }
            });
        });

        $form.appendTo($appendTo);
        $form.find('[data-toggle="popover"]').popover();

        $('#dn-compose-upload' + parentKey)
        .click
        (
            function () 
            {
                if (!dn.user.CanUpload)
                {
                    dn.PromptToUpgrade("CanUpload");
                }
                else
                {
                    compose.UploadFiles($form);
                }
            }
        );

        $('#dn-compose-Metadata' + parentKey)
        .collapse
        ({
            toggle: false
        });

        $('#dn-compose-Metadata' + parentKey).on('show.bs.collapse', function (event) 
        {
            // when showing
            $('#dn-compose-add-metadata' + parentKey).addClass('dn-pressed').find('svg').removeClass('fa-plus').addClass('fa-minus');
            $('#dn-compose-add-metadata' + parentKey).find("span").text("Hide Metadata");
        });

        $('#dn-compose-Metadata' + parentKey).on('hide.bs.collapse', function (event) 
        {
            // when hiding
            $('#dn-compose-add-metadata' + parentKey).removeClass('dn-pressed').find('svg').addClass('fa-plus').removeClass('fa-minus');
            $('#dn-compose-add-metadata' + parentKey).find("span").text("Show Metadata");
        });

        var setType = button.data('set-type');
        if (setType)
        {
            // they want to explicitly set a type when the form loads
            compose.Selectize[id + '-Type'].clear(true);
            compose.Selectize[id + '-Type'].addItem(setType);
            button.data('set-type', null);  // don't do this twice
        }          
    };

    /**
     * Setup the given text fields to listen for `focus` events (which get
     * processed by `HandleEditorFocus`, and typing/change events, which get
     * handled by TypeWatch).
     */
    compose.SetupTextFields = function($element, $form)
    {
        var parentKey = $form.data("parentkey");

        console.debug("compose.SetupTextFields", "Setup", $element);

        $element.on('focus', compose.HandleEditorFocus);
        $element.typeWatch
        (
            {
                callback: function (value) 
                { 
                    console.debug("compose.SetupTextFields", "TypeWatch", this, value);

                    // Clear any errors that were there
                    var selector = $(this).attr("id") + parentKey;
                    $form.find("#" + selector + ", .input-group." + selector).removeClass("is-invalid");
                    $form.find("#" + selector + '-error').text("").hide();

                    compose.Save($form, false); 
                },
                wait: dn.constants.WaitForAutosave,
                highlight: false,
                allowSubmit: false,
                captureLength: 0
            }
        );
    };

    /**
     * Show a modal for the specified badges, indicating the user doesn't
     * have permission to perform the prevented action due to lack of those badges
     *     
     * @param {string}      badgeIds - The list of badge Id's required to perform
     * @param {string}      preventingActionOnTopic - The action such as 'post on' 
     */
    compose.ShowMissingBadgeModalForTopicAction = function(badgeIds, preventingActionOnTopic)
    {
        var missingBadgeMessagesHTML = dn.compose.GenerateBadgesHTML(badgeIds);
        var body = "This topic requires the " + missingBadgeMessagesHTML + " badge " + (badgeIds.length > 1 ? "s" : "") + 
            " to " + preventingActionOnTopic + ".";
        dn.ShowModal({ title: "Missing Badges", body: body });
    }

    /**
     * Handle the display of any info about the chosen type.
     */
    compose.ShowTypeInfo = function($form, parentKey, typeId)
    {
        console.debug("compose.ShowTypeInfo", parentKey, typeId);

        if (parentKey)
        {
            // A reply to a message
            $form.find(".dn-compose-info").hide();
            $form.find(".dn-post-type").html('&nbsp;Reply');
        }
        else if (typeId)
        {
            // A new message with a type defined
            var chosenType = dn.constants.DiscussionTypes[typeId];

            if (chosenType)
            {
                if (chosenType.Warning)
                {
                    $form.find("#dn-compose-" + parentKey + "-info").html(chosenType.Warning);
                    $form.find(".dn-compose-info").show();
                }
                else
                {
                    $form.find(".dn-compose-info").hide();
                }

                $form.find(".dn-post-type").html('&nbsp;' + chosenType.Name);
            }
        }
        else
        {
            // New message without a type defined yet
            $form.find(".dn-compose-info").hide();
            $form.find(".dn-post-type").html('&nbsp;Message');
        }
    }

    /**
     * Start a new post of a given type.
     */
    compose.StartPost = function(typeId, elementToDelete) 
    {
        if (elementToDelete)
        {
            $(elementToDelete).remove();
        }

        if ($('.dn-compose-button').data('dn-current-status') === 'open')
        {
            // already open, just set Bounty type if the "Add Bounty" box isn't already open
            if (!$('div.dn-add-bounty') || !$('div#' + compose.AddBountyId).hasClass('show'))
            {
                compose.Selectize['dn-compose-Type'].clear(true);
                compose.Selectize['dn-compose-Type'].addItem(typeId);
            }
        }
        else
        {
            // Not open yet, set the desired type, and then toggle the form open.
            $('.dn-compose-button').data('set-type', typeId).click();
        }
    };

    /**
     * Start a new compose form for either new message or replies. 
     */
    compose.Toggle = function (event) 
    {
        var $togglingButton = $(event.currentTarget);

        // don't allow posting if the user is not logged in
        if (!dn.user.IsLoggedIn) 
        {
            dn.PromptToLogin('post a message');
            return;
        }
        else if (dn.IsDiscussionAnonymized)
        {
            dn.PromptToSubscribe(dn.CurrentTopicId, 'post a message', function(e) { window.location.reload(); });
            return;
        }

        var appendTo = $($togglingButton.data('dn-append-to'));
        var status = $togglingButton.data('dn-current-status');

        // available for reply button clicks
        var parentKey = $togglingButton.data('dn-parentkey');

        // available for edit button clicks
        var messageKey = $togglingButton.data('dn-messagekey');

        if (status !== 'open')
        {
            // Form isn't being displayed currently, so create the form (if needed), and then display it

            // Get the MessageKey that we should use for this new post
            $.postJSON("/api/v1/message", 
            {
                MessageKey: (messageKey || null),   // should only be non-null for editing completed messages
                ParentKey: (parentKey || null),
                DisableRichTextEditing: !dn.constants.UseRichTextEditor
            })
            .done(function(response) 
            {
                messageKey = response.Message.MessageKey;
                compose.Messages[messageKey] = response.Message;

                var $form = compose.GetForm($togglingButton, messageKey, response.TypeManager);

                // Initial validation of topics that are already loaded.
                // Wrapped in a timeout because something is causing any initial error
                // message to be hidden, but I wasn't able to track down what.
                setTimeout(function() { compose.ValidateTopics($form) }, 10);

                $togglingButton.data('dn-current-status', 'open');
                $form.show();

                if (compose.IsEdit($form)) 
                {
                    // This is an edit, so hide the existing message when showing the input form.
                    $(event.target).closest(".dn-message").hide();
                    appendTo.removeClass('d-none').addClass('dn-edit-box');

                    // If the reply form has already been opened, toggle it closed since they decided to edit instead.
                    if ($('button[data-dn-parentkey="' + messageKey + '"]').data('dn-current-status') === 'open')
                    {
                        $('button[data-dn-parentkey="' + messageKey + '"]').click();
                    }
                } 
                else 
                {
                    appendTo.collapse('show');
                }

                // change the triggering button class/text
                $togglingButton.addClass("dn-pressed").children('span').text($togglingButton.data('dn-button-label-open'));
            })
            .fail(function(xhr, textStatus, errorThrown) 
            {
                if (!dn.IsErrorHandledAutomatically(null, xhr, null, errorThrown)) 
                {
                    // The initial request for the message details failed, tell the user
                    var body = dn.FormatApiError(xhr.responseJSON);
                    dn.ShowModal({ title: "Unexpected Error", body: body });
                }
            });
        }
        else
        {
            // save draft and close the form down
            var $form = appendTo.find('#dn-compose' + parentKey);

            compose.ResetErrors($form);
            compose.Save($form, false, function () 
            {
                $togglingButton.data('dn-current-status', 'closed');

                if (compose.IsEdit($form)) 
                {
                    appendTo.addClass('d-none').removeClass('dn-edit-box');
                }
                else 
                {
                    appendTo.collapse('hide');
                }

                // $togglingButton.children('svg').removeClass("fa-minus-square").addClass("fa-plus-square");
                $togglingButton.removeClass("dn-pressed").children('span').text($togglingButton.data('dn-button-label-closed'));
            });
        }
    };

    /**
     * Toggle the topics/groups dropdown open or closed. 
     */
    compose.ToggleTopicsDropdown = dn.Debounce(function(event) 
    {
        if ($('div.selectize-input.dropdown-active').length)
        {
            // it's already open, so close it.
            dn.compose.Selectize['dn-compose-Topics'].close();
        }
        else
        {
            // it's closed, so open it.
            dn.compose.Selectize['dn-compose-Topics'].open();
        }
    }, 200, true);

    /**
     * See https://www.filestack.com/docs/javascript-api/pick-v3
     * 
     * @param {object} [options] Any options allowed by Filestack.
     */
    compose.UploadFiles = function($form) 
    {
        compose.FileUploader.pick(compose.FileUploaderOptions).then(function(response) 
        {
            var key = 'files' + $form.data('parentkey');

            if (!compose.FileKeys[key]) 
            {
                compose.FileKeys[key] = [];
                compose.FileTypes[key] = [];
            }

            compose.HandleFiles
            (
                response,
                compose.FileKeys[key], 
                compose.FileTypes[key], 
                // After handling save the changes to our draft
                function()
                {
                    compose.Save
                    (
                        $form, 
                        false, 
                        function() 
                        {
                            compose.EmbedFiles($form);
                        }
                    );
                }
            );
        });
    };

    /**
     * Update the body and metadata section of the given form, based on the message data
     * stored in the `msg` parameter. This might be called when the compose form
     * is first being created for a new message (no type known), or called after
     * the type has been set for the first time, or after the type has been changed.
     * 
     * When possible, we'll try to retain previously entered metadata when the type
     * is being changed around, if known.
     * 
     * If the type is changed from the multipart type to another type, we'll use the 
     * DiscussionType.BodyTemplate to form the new unified message body. If the user 
     * is going from a non-multipart type to a multipart type, the first body part 
     * will be filled in with the previous Body value.
     * 
     * @param {element} $form                   - The form we want to fill these values into.
     * @param {object}  msg                     - The message that the person was working on, if any.
     * @param {bool}    typeManagerStatusEditor - True if this user is a type manager approved to change message status, 
     *                                            NOT the author of the root message. We use this knowledge when deciding 
     *                                            whether to show them the option to set a Status, as well as in how we 
     *                                            display the status options to them.
     * @param {bool}    isInitialSetup          - Whether this is the first time this form is being setup.
     */
    compose.UpdateBodyAndMetadata = function($form, msg, typeManagerStatusEditor, isInitialSetup)
    {
        var parentKey = $form.data("parentkey");
        var typeId = $form.data("type-id");
        var type = dn.constants.DiscussionTypes[typeId];

        // Whether or not this form was previously setup for multipart body or not.
        var wasMultipart = $form.data("is-multipart");
        var isNowMultipart = false; // we may update this later

        var id = 'dn-compose' + parentKey;
        var $metadata = $form.find(".dn-compose-Metadata");

        // Start with our standard body, used by replies and non-multipart body types. 
        // This is our default type if we don't know what type it is yet.
        var body = dn.constants.UseRichTextEditor 
            ? '<div class="dn-compose-Body bg-secondary" id="' + id + '-Body"></div><div class="invalid-feedback mx-1 mx-sm-0" data-placeholder="" id="dn-compose-Body' + parentKey + '-error"></div>' 
            : '<textarea class="dn-compose-Body bg-secondary ' + dn.constants.Classnames.TextOnlyEditor + '" data-placeholder="" id="' + id + '-Body" style="padding: 10px; display: inline-block; width: 100%;" /><div class="invalid-feedback mx-1 mx-sm-0" id="dn-compose-Body' + parentKey + '-error"></div>';

        console.debug("compose.UpdateBodyAndMetadata", type);

        if (type)
        {
            if (!parentKey)
            {
                isNowMultipart = type.Template.IsBodyMultipart;
                $form.data("is-multipart", isNowMultipart);   // save for later

                if (isNowMultipart)
                {
                    $form.data("last-multipart-type-id", type.TypeId); // we use this when the person converts from multipart to single body

                    if (!isInitialSetup && wasMultipart)
                    {
                        // No change, multipart => multipart, so clear the body so we don't reset it
                        body = null;
                    }
                    else
                    {
                        // Setup the multipart body, first clear out the default single part body, then iterate over bodyparts
                        body = "";

                        // This is a multi-part body type 
                        if (dn.constants.UseRichTextEditor)
                        {
                            // Use CKEditor for each of the body parts since this client supports rich text editing
                            type.Template.BodyParts.forEach
                            (
                                function(bodyPart)
                                {
                                    console.debug("compose.UpdateBodyAndMetadata", bodyPart);

                                    body += '<p class="dn-bodypart-header mb-0">' + bodyPart.Header + '</p><div class="dn-compose-Body dn-compose-Body-multipart bg-secondary" data-placeholder="' + bodyPart.Placeholder + '" id="' + id + '-Body-' + bodyPart.PartKey + '"></div><div class="invalid-feedback mx-1 mx-sm-0" id="' + id + '-Body-' + bodyPart.PartKey + '-error"></div>';
                                }
                            );
                        }
                        else
                        {
                            // Use textareas for each of the body parts since this client does NOT support rich text editing
                            type.Template.BodyParts.forEach
                            (
                                function(bodyPart)
                                {
                                    console.debug("compose.UpdateBodyAndMetadata", bodyPart);

                                    body += '<p class="dn-bodypart-header mb-0">' + bodyPart.Header + '</p><textarea class="dn-compose-Body dn-compose-Body-multipart bg-secondary ' + dn.constants.Classnames.TextOnlyEditor + '" style="padding: 10px; display: inline-block; width: 100%;" placeholder="' + bodyPart.Placeholder + '" id="' + id + '-Body-' + bodyPart.PartKey + '"/><div class="invalid-feedback mx-1 mx-sm-0" id="' + id + '-Body-' + bodyPart.PartKey + '-error"></div>';
                                }
                            );
                        }
                    }
                }
                else if (!isInitialSetup && !wasMultipart)
                {
                    // No change, single => single, so clear the body so we don't reset it
                    body = null;
                }
            }

            var numFields = 0;
            var numFieldsFilled = 0;

            if ($metadata.length > 0)
            {
                // Clear any existing metadata
                $metadata.html(""); 

                // This is NOT a reply, and we have a type, so handle metadata here.
                // Iterate over every metadata field associated with this message type
                type.Template.Fields.forEach
                (
                    function(field)
                    {
                        if (parentKey && !field.AllowedOnReplies)
                        {
                            // This message is a reply, and this field is not allowed on replies, so skip it.
                            return;
                        }

                        numFields++;

                        var metadata = dn.constants.Metadata[field.MetadataId];

                        // define a unique identifier for this metadata key
                        var uniqueId = id + "-" + type.Template.TemplateKey + "-" + metadata.MetadataKey;

                        if (metadata.Type === dn.constants.MetadataType.Autosuggest)
                        {
                            $metadata.append
                            (
                                '<div class="form-group col-12 pr-0">\
                                    <div class="input-group ' + uniqueId + '">\
                                        <div class="input-group-prepend">\
                                            <label class="input-group-text px-1" for="' + uniqueId + '">' + field.Title + '</label>\
                                        </div>\
                                        <input autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" class="form-control dn-autosuggest-field" id="' + uniqueId + '" data-role="tagsinput" type="text" placeholder="' + field.Placeholder + '">\
                                    </div>\
                                    <div class="invalid-feedback mx-1 mx-sm-0" id="' + uniqueId + '-error"></div>\
                                </div>'
                            );

                            // Prep the OnItemAdd function, or turn it into a no-op if none provided
                            metadata.Options.OnItemAdd = eval(metadata.Options.OnItemAdd || "(function(itemId, item, $element, $form, callback) { if (callback) { callback(); }})");

                            // Figure out what items to pre-fill or make available. 
                            var itemsAvailable = [];
                            var itemsSelected = [];

                            if (msg.Metadata && msg.Metadata[metadata.MetadataKey])
                            {
                                // The user has already made a selection, so those items will be added 
                                // to both the available/selected lists.
                                itemsAvailable = msg.Metadata[metadata.MetadataKey];

                                // Get an array of the unique identifiers for the available
                                // items, as dictated by the `Identifier`, which tells us the
                                // name of the metadata property used as the unique identifier.
                                itemsSelected = msg.Metadata[metadata.MetadataKey].map
                                (
                                    function(item) 
                                    {
                                        return item[metadata.Options.Identifier];
                                    }
                                );

                                numFieldsFilled++;
                            }

                            if (metadata.Options.ItemsAvailable)
                            {
                                // Template calls for some default available items of its own, so 
                                // append to the existing itemsAvailable.
                                itemsAvailable.push.apply(itemsAvailable, metadata.Options.ItemsAvailable);
                            }

                            if (metadata.Options.ItemsSelected)
                            {
                                // Template calls for some default selected items of its own, so 
                                // append to the existing itemsAvailable.
                                itemsSelected.push.apply(itemsSelected, metadata.Options.ItemsSelected);
                            }


                            // Wire up the autosuggestion capability via selectize library. Items specified in
                            // the `options` and/or `items` properties should be objects with properties, not just strings.
                            // You can then define which of the item's properties are used as the reported "value" of
                            // the item when selected (via `valueField`), which properties are searched (via `searchField`),
                            // and how things should be rendered.
                            // compose.Selectize[uniqueId] = $metadata.find('#' + uniqueId)
                            //  .selectize( )[0].selectize;
                            dn.metadata.CreateSelectize
                            (                           
                                $metadata, // The html to search/append to
                                uniqueId, // Target Field
                                metadata, // The metadata
                                { // Options
                                    ItemsAvailable : itemsAvailable,
                                    ItemsSelected : itemsSelected,
                                    MaxItems : field.MaxItems
                                },

                                function(itemId, $element) {//onItemAddedFunction
                                    metadata.Options.OnItemAdd(itemId, dn.metadata.Selectize[uniqueId].options[itemId], $element, $form, function()
                                    {
                                        $element.find('[data-toggle="popover"]').popover();
                                        compose.Save($form, false);
                                    });
                                },

                                function(itemId, $element)
                                {
                                    // If a popover has been defined, this will remove it.
                                    $element.find('[data-toggle="popover"]').popover('dispose');
                                    dn.compose.Save($form, false);
                                }
                            );

                            console.debug("compose.UpdateBodyAndMetadata", "Autosuggest", field.Title);
                        }
                    }
                );
            }

            if (parentKey)
            {
                if (numFields > 0)
                {
                    // Only show the "Show Metadata" button if there are fields to show.
                    var $metadataButton = $form.find(".dn-compose-add-metadata");
                    if (numFieldsFilled > 0)
                    {
                        // Since some fields are filled, expand the metadata section.
                        $metadataButton.removeClass("d-none").addClass("d-inline-block");

                        // Expand the form
                        setTimeout(function() { $("#dn-compose-Metadata" + parentKey).collapse('show'); }, 100);
                    }
                    else
                    {
                        // Just show the button, don't click it to expand.
                        $metadataButton.removeClass("d-none").addClass("d-inline-block");
                    }
                }
                else
                {
                    // No fields, so hide the "Show Metadata" button.
                    $form.find(".dn-compose-add-metadata").addClass("d-none").removeClass("d-inline-block");
                }
            }
        }
        else if (!isInitialSetup && !wasMultipart)
        {
            // Either an initial single body setup, or a switch from multipart to single
            body = null;
        }

        // First clear any existing body typing listeners.
        $form.find("#dn-compose-Body").off("keydown paste cut input");  // Re: https://github.com/dennyferra/TypeWatch/issues/36#issuecomment-722637558

        if (body)
        {
            // Since `body` is set, we know we need to make any changes needed 
            // to the Body part of the form.
            console.debug("compose.UpdateBodyAndMetadata", "Setting Body", (isNowMultipart ? "Multipart" : "Single"));
            $form.find(".dn-body-wrapper").html(body);

            var $bodyParts = $form.find(".dn-compose-Body");
            var idxLastBodyPart = $bodyParts.length - 1;

            // Setup the body parts
            $bodyParts.each
            (
                function(idx, element) 
                { 
                    var $element = $(this);
                    var editorId = $element.attr("id");

                    if ($element.is("div"))
                    {
                        // this is a rich text editor field

                        dn.LoadRichTextEditor
                        (
                            function()
                            {
                                console.debug("compose.UpdateBodyAndMetadata", "dn.LoadRichTextEditor", "onComplete Executed");

                                // set up CKEditor
                                BalloonEditor.create
                                (
                                    element, 
                                    // Merge in our custom placeholder for this CKEditor instance
                                    Object.assign
                                    (
                                        {
                                            placeholder: $element.data("placeholder")
                                        }, 
                                        dn.constants.HtmlEditorConfig
                                    )
                                )
                                .then(function (editor) 
                                {
                                    console.debug("compose.UpdateBodyAndMetadata", "RichText", idx, editorId);
                                    editor.editing.view.document.on('drop', compose.HandleFileDrop, {Editor: editor});
                                    compose.Editors[editorId] = editor;

                                    if (idx === 0)
                                    {
                                        // Only set LastEditor during setup if it hasn't been set yet
                                        compose.LastEditor = editor;
                                    }

                                    if (idx === idxLastBodyPart)
                                    {
                                        // We've setup the last element, so go ahead and fill in the form
                                        compose.FillForm($form, msg.MessageKey, typeManagerStatusEditor);
                                        compose.SetupTextFields($form.find(dn.constants.EditorSelector), $form);
                                    }
                                })
                                .catch(function (error) 
                                {
                                    console.error("compose.UpdateBodyAndMetadata", error);
                                });
                            }
                        );
                    }
                    else
                    {
                        console.debug("compose.UpdateBodyAndMetadata", "PlainText", idx, editorId);

                        compose.Editors[editorId] = $element;

                        if (idx === 0)
                        {
                            // Only set LastEditor during setup if it hasn't been set yet
                            compose.LastEditor = $element;
                        }

                        if (idx === idxLastBodyPart)
                        {
                            // We've setup the last element, so go ahead and fill in the form
                            compose.FillForm($form, msg.MessageKey, typeManagerStatusEditor);
                            compose.SetupTextFields($form.find(dn.constants.EditorSelector), $form);
                        }
                    }
                }
            );
        }
    };

    /**
     * Whenever we make a change to our topics and groups for our compose form, we should call
     * this validation routine to adjust the form display to convey any warnings needed, such 
     * as letting them know when they have too many topics, too many groups, too many groups of
     * a certain kind (closed/private), or a mix of open and non-open groups.
     */
    compose.ValidateTopics = function($form)
    {
        // Get the allowed topics for the current message type, or null if no type or it doesn't have AllowedTopics
        var typeId = $form.data("type-id");
        var type = null;
        var allowedTopics = null;
        var allowedTopicReason = null;

        if (typeId)
        {
            type = dn.constants.DiscussionTypes[typeId];
            if (type.AllowedTopics.length !== 0)
            {
                allowedTopics = dn.constants.DiscussionTypes[typeId].AllowedTopics;

                // Construct a clear error message, which can vary depending on whether both topics AND groups are allowed.
                var allowedGroupIds = allowedTopics.filter(function(topicId) { return !dn.constants.Topics[topicId].IsTopic; });
                var allowedGroupNames = dn.text.JoinForHumans(allowedGroupIds.map(function(topicId) { return dn.constants.Topics[topicId].Name; }).sort(), '</b>, <b>', '</b>, and <b>', '</b> and <b>');
                var allowedTopicIds = allowedTopics.filter(function(topicId) { return dn.constants.Topics[topicId].IsTopic; });
                var allowedTopicNames = dn.text.JoinForHumans(allowedTopicIds.map(function(topicId) { return dn.constants.Topics[topicId].Name; }).sort(), '</b>, <b>', '</b>, and <b>', '</b> and <b>');

                if (allowedGroupIds.length > 0 && allowedTopicIds.length > 0)
                {
                    // Groups and topics are allowed... LEAD with the groups that are allowed, they're more important
                    allowedTopicReason = 'You can only post <i>' + type.NamePluralized + '</i> to ' + (allowedGroupIds.length === 1 ? 'the <b>' + allowedGroupNames + '</b> user group' : 'user groups <b>' + allowedGroupNames + '</b>') + ', and ' + (allowedTopicIds.length === 1 ? 'the <b>' + allowedTopicNames + '</b> topic' : 'topics <b>' + allowedTopicNames + '</b>') + '.';
                }
                else
                {
                    // Only topics or only groups are allowed, just do one list of items
                    allowedTopicReason = 'You can only post <i>' + type.NamePluralized + '</i> to <b>' + allowedTopicNames + '</b>.';
                }
            }
        }

        // If they add more than the allowed topics/groups, we need to show an error
        // message, and highlight the item(s) that are putting them over the top.
        var topics = 0;
        var groups = 0;
        var groupsOpen = 0;
        var groupsClosed = 0;
        var groupsPrivate = 0;
        var errors = {};

        var topicIds = dn.compose.Selectize['dn-compose-Topics'] && $.isArray(dn.compose.Selectize['dn-compose-Topics'].items) && dn.compose.Selectize['dn-compose-Topics'].items.length > 0
            ? dn.compose.Selectize['dn-compose-Topics'].items
            : [];

        var closedOrPrivate = false;

        // Iterate through the current topics/groups to get a breakdown of counts of each
        // type of topic/group. We will highlight the topics/groups that put us over our 
        // allowed limits. If there are more than one closed/private group, then we will 
        // flag the closedOrPrivate as true, this helps later to determine whether or not
        // to enforce badge requirements on any other topics.
        var topicObjects = $.map
        (
            topicIds, 
            function(value, index) 
            {
                var topic = dn.compose.Selectize['dn-compose-Topics'].options[value];
                if (topic.IsPrivateGroup || topic.IsClosedGroup)
                {
                    closedOrPrivate = true;
                }
                return topic;
            }
        );

        $.each
        (            
            topicObjects,
            function(index, topic) 
            {
                var shouldRemove = false;
                var removalReason = null;

                // Look for missing badges, unless this post is going to a closed or private user group,
                // in which case if this current topic object is a topic (not a group), then we ignore
                // and badge requirements.
                var missingRequiredBadges = (closedOrPrivate && topic.IsTopic) ? [] : topic.RequiredBadges.filter(function(b) { return !dn.user.BadgeIds.has(b) });

                // If this error logic is changed, make sure it's changed in PutMessageViewModel.Validate() as well.
                if (missingRequiredBadges.length != 0)
                {
                    var badgeErrorMessage = "";

                    for (var i = 0; i < missingRequiredBadges.length; i++)
                    {
                        var currentBadge = dn.constants.Badges[missingRequiredBadges[i]];
                        badgeErrorMessage += 'The <b>' + topic.Name + '</b> ' + (topic.IsGroup ? 'user group' : 'topic') + ' requires the <a href="' + currentBadge.Link + '" class="dn-badge" style="' + currentBadge.Styles + '">' + currentBadge.Name + '</a> badge to participate.<br>';
                    }

                    shouldRemove = true;
                    errors[badgeErrorMessage] = 1;
                }
                else if (dn.user.Experience < topic.MinimumExperience && (topic.IsGroup || (groupsClosed === 0 && groupsPrivate === 0)))
                {
                    // This topic/group has a minimum experience level requirement that was not met, AND it's 
                    // either a group or it's a topic AND there are no closed/private groups that
                    // have been processed already before it. (Because if there were private/closed groups that 
                    // came before it, we will allow them to skip the experience requirements.)
                    shouldRemove = true;
                    removalReason = 'The <b>' + topic.Name + '</b> ' + (topic.IsGroup ? 'user group' : 'topic') + ' requires a minimum experience level of <u>' + topic.MinimumExperience + ' years</u> to participate.';
                    errors[removalReason] = 1;
                }               
                else if (allowedTopics && allowedTopics.indexOf(topic.TopicId) === -1)
                {
                    // This message type does limit where it can be posted, so indicate they need to drop this
                    // topic because it's not in the allowed list.
                    shouldRemove = true;
                    errors[allowedTopicReason] = 1;
                }
                else if (topic.IsClosedGroup && dn.user.TopicSubscriptions.indexOf(topic.TopicId) === -1)
                {
                    // Trying to send to a closed group of which they aren't yet a subscriber
                    shouldRemove = true;

                    removalReason = 'You need to <a href="#" class="subscribe-topic" data-topic-id="' + topic.TopicId + '" data-topic-key="' + topic.TopicKey + '" data-topic-name="' + dn.text.QuoteAttribute(topic.Name) + '" data-topic-required-badges="' + JSON.stringify(topic.RequiredBadges) + '">subscribe to <b>' + topic.Name + '</b></a> to post to it.';
                    errors[removalReason] = 1;
                }

                if (topic.IsGroup)
                {
                    groups++;

                    if (groups > dn.constants.DiscussionMaxGroups)
                    {
                        shouldRemove = true;
                        removalReason = 'You cannot post to more than ' + dn.constants.DiscussionMaxGroups + ' groups at a time.';
                        errors[removalReason] = 1;
                    }

                    if (topic.IsOpenGroup)
                    {
                        groupsOpen++;
                        if (groupsClosed > 0)
                        {
                            shouldRemove = true;
                            removalReason = 'You cannot post to both open <i>and</i> closed groups at the same time.';
                            errors[removalReason] = 1;
                        }
                        else if (groupsPrivate > 0)
                        {
                            shouldRemove = true;
                            removalReason = 'You cannot post to both open <i>and</i> private groups at the same time.';
                            errors[removalReason] = 1;
                        }
                    }
                    else if (topic.IsClosedGroup)
                    {
                        groupsClosed++;
                        if (groupsClosed > 1)
                        {
                            shouldRemove = true;
                            removalReason = 'You can only post to <i>one</i> closed group at a time.';
                            errors[removalReason] = 1;
                        }
                        else if (groupsOpen > 0)
                        {
                            shouldRemove = true;
                            removalReason = 'You cannot post to both closed <i>and</i> open groups at the same time.';
                            errors[removalReason] = 1;
                        }
                        else if (groupsPrivate > 0)
                        {
                            shouldRemove = true;
                            removalReason = 'You cannot post to both closed <i>and</i> private groups at the same time.';
                            errors[removalReason] = 1;
                        }
                    }
                    else
                    {
                        groupsPrivate++;

                        if (groupsPrivate > 1)
                        {
                            shouldRemove = true;
                            removalReason = 'You can only post to <i>one</i> private group at a time.';
                            errors[removalReason] = 1;
                        }
                        else if (groupsOpen > 0)
                        {
                            shouldRemove = true;
                            removalReason = 'You cannot post to both private <i>and</i> open groups at the same time.';
                            errors[removalReason] = 1;
                        }
                        else if (groupsClosed > 0)
                        {
                            shouldRemove = true;
                            removalReason = 'You cannot post to both private <i>and</i> closed groups at the same time.';
                            errors[removalReason] = 1;
                        }
                    }
                }
                else
                {
                    topics++;
                    if (topics > dn.constants.DiscussionMaxTopics)
                    {
                        shouldRemove = true;
                        removalReason = 'You cannot post to more than ' + dn.constants.DiscussionMaxTopics + ' topics at a time.';
                        errors[removalReason] = 1;
                    }
                }

                if (dn.compose.Selectize['dn-compose-Topics'].options[topic.TopicId].ShouldRemove != shouldRemove)
                {
                    // re-save and re-render this option since "should remove" status has changed
                    dn.compose.Selectize['dn-compose-Topics'].options[topic.TopicId].ShouldRemove = shouldRemove;
                    dn.compose.Selectize['dn-compose-Topics'].options[topic.TopicId].RemovalReason = removalReason;
                    dn.compose.Selectize['dn-compose-Topics'].updateOption(topic.TopicId, compose.Selectize['dn-compose-Topics'].options[topic.TopicId]);
                    $('[data-value="' + topic.TopicId + '"] span.topic-name').popover();
                }
            }
        );

        var errorsArray = Object.keys(errors);
        if (errorsArray.length > 0)
        {
            $form.find('#dn-compose-Topics-error').html(errorsArray.join(" ")).show();
            $form.find('.subscribe-topic').click(function(event)
            {
                dn.topic.HandleSubscribeClick(event, function(response)
                {
                    if (response.Action === dn.topic.TopicAction.Queued)
                    {
                        // Likely queued up for a closed group
                        dn.ShowModal({ title: "Subscription Requested", body: "Your request to join this closed group has been sent to the group managers. If they approve or reject your request, you'll receive an email notification." });
                    }
    
                    // After subscribing, re-validate the topics to remove the error message if possible
                    compose.ValidateTopics($form);
                });
            });

            $form.find("button.dn-compose-post").prop('disabled', true); // disable the post button
            dn.compose.Selectize['dn-compose-Topics'].close(); // close the topics dropdown so they can see the error
        }
        else
        {
            $form.find("button.dn-compose-post").prop('disabled', false); // enable the post button
            $form.find(".input-group.dn-compose-Topics").removeClass("is-invalid");
            $form.find('#dn-compose-Topics-error').html("").hide();
        }

        // Keep track of whether they are mixing open groups with closed/private, which is not allowed.
        var mixedGroupTypes = (groupsOpen && (groupsClosed || groupsPrivate));
        $form.data('mixed-group-types', mixedGroupTypes);

        return errorsArray;
    };

    $(document).ready
    (
        function ($)
        {
            // Process any queued functions now that the namespace is ready.
            dn.ProcessQueuedFunctions('dn.compose');
        }
    );

}(window.dn.compose = window.dn.compose || {}, jQuery));


